/**
 * UI copy for Spanish (es) and English (en).
 * Nested keys; use t('nav.pricing') from LanguageContext.
 */

const translations = {
  es: {
      nav: {
      pricing: 'Precios',
      blog: 'Guías',
      hello: 'Hola, {name}',
      dashboard: 'Panel',
      account: 'Cuenta',
      logout: 'Salir',
      login: 'Iniciar sesión',
      signup: 'Crear cuenta',
      tryApp: 'Mejorar mi CV',
      langEs: 'ES',
      langEn: 'EN',
      langLabel: 'Idioma',
      planPro: 'Pro',
      planFree: 'Gratis',
      mainNav: 'Navegación principal',
    },
    footer: {
      tagline: 'Tu CV, listo para que te lean. La IA no entrena con tus datos',
      home: 'Inicio',
      pricing: 'Precios',
      blog: 'Guías',
      feedback: 'Feedback',
      privacy: 'Privacidad',
      terms: 'Términos',
      cookies: 'Cookies',
      login: 'Iniciar sesión',
      navLabel: 'Enlaces del pie',
    },
    a11y: {
      skipToContent: 'Saltar al contenido',
      loading: 'Cargando…',
    },
    cookies: {
      regionLabel: 'Cookies',
      requiredLead: 'Elige cookies de analítica antes de subir o analizar tu CV.',
      body:
        'Cookies de analítica (p. ej. Google Analytics) para mejorar el sitio. La grabación de sesión es opcional y va aparte.',
      sessionReplay:
        'También permitir grabación de sesión (Microsoft Clarity). Puede grabar pantallas del producto y mostrar el texto de tu CV y formularios de forma legible (las contraseñas se enmascaran). Tratamiento por Microsoft. Puedes retirarlo en Cookies.',
      accept: 'Aceptar',
      reject: 'Rechazar',
      privacy: 'Privacidad',
    },
    legal: {
      privacyTitle: 'Política de privacidad',
      privacyDescription:
        'Cómo ClarCV recoge y usa tus datos: cuenta, CVs, pagos con Stripe e IA. No vendemos tu información ni entrenamos modelos con tu CV.',
      termsTitle: 'Términos de uso',
      termsDescription:
        'Condiciones para usar ClarCV: cuenta, planes, tu contenido y límites de responsabilidad.',
    },
    blog: {
      indexTitle: 'Guías para mejorar tu CV',
      indexDescription:
        'Artículos prácticos sobre CV, filtros ATS, cómo hacer un currículum con ChatGPT o Gemini, prompts de IA y cómo mejorar el PDF que ya tienes. ClarCV.',
      indexLead:
        'Guías largas y claras para pasar filtros ATS, usar ChatGPT sin inventar datos, y mejorar tu PDF o Word — sin paywalls raros.',
      minRead: 'min de lectura',
      back: 'Todas las guías',
      notFound: 'Artículo no encontrado',
      ctaText: '¿Quieres aplicar esto a tu CV ahora?',
      ctaButton: 'Mejorar mi CV en ClarCV',
      ctaUploadTitle: 'El chat redacta. El ATS lee tu archivo',
      ctaUploadLead: 'Cuando tengas el borrador, súbelo en PDF o Word y comprueba si pasa el filtro.',
      ctaUploadChatText: 'Borrador en el chat',
      ctaUploadFileText: 'PDF o Word al filtro',
      ctaUploadButton: 'Subir mi CV',
      ctaUploadFine: 'Gratis · sin tarjeta · 1 análisis ATS de vista previa. PDF al pagar.',
      related: 'Guías relacionadas',
      faqHeading: 'Preguntas frecuentes',
      filterAll: 'Todas',
      filterLabel: 'Filtrar por tema',
      guidesCount: 'guías',
      promptLabel: 'Prompt para copiar',
      promptCopy: 'Copiar',
      promptCopied: 'Copiado',
    },
    notFound: {
      title: 'Página no encontrada',
      lead: 'Esa URL no existe o se ha movido. Vuelve al inicio o al blog.',
      home: 'Ir al inicio',
      blog: 'Ver guías del blog',
    },
    landing: {
      heroEyebrow: 'IA + filtro ATS',
      heroTitleLead: 'Mejora tu CV para el',
      heroTitleAccent: 'puesto que quieres',
      heroStep1: 'Sube tu PDF o Word, o empieza desde cero',
      heroStep2: 'Dinos el puesto: la IA te dice qué cambiar',
      heroStep3: 'Elige una plantilla y descárgalo en PDF o Word',
      metaTitle: 'Mejora tu CV para el puesto que quieres · ClarCV',
      metaDescription:
        'Sube tu CV o empieza desde cero. La IA reescribe hacia el puesto, aplica plantilla y descarga en PDF o Word. Empieza gratis, sin tarjeta.',
      ctaStart: 'Mejorar mi CV',
      ctaBlank: 'Crear desde cero',
      ctaDashboard: 'Ir al panel',
      heroFine: 'Gratis · sin tarjeta · editas en el navegador. PDF al pagar.',
      heroAiLabel: 'Asistencia con IA',
      heroAiText: 'Reescribe tu CV sin inventar datos ni métricas',
      ariaHero: 'Presentación',
      ariaTrust: 'Confianza',
      trustPrice: 'Gratis',
      trustPriceText: 'Sin tarjeta. Empieza gratis; el PDF se descarga al pagar',
      trustFiles: 'PDF y Word',
      trustFilesText: 'Descargas reales, listas para enviar',
      trustPay: 'Pro mes a mes',
      trustPayText: '7 €/mes. Cancela cuando quieras',
      trustPrivacy: 'Privacidad',
      trustPrivacyShort: 'Tu CV no entrena modelos de IA',
      trustLang: 'ES + EN',
      trustLangText: 'App en tu idioma. CV en el idioma que necesites',
      pathsTitle: 'Elige cómo empezar',
      pathsLead:
        'Con tu PDF o Word: informe ATS o CV reescrito por IA con plantilla. Sin archivo: editor desde cero',
      pathsFileEyebrow: 'Ya tienes un PDF o Word',
      pathAtsTitle: 'Informe ATS (solo consejo)',
      pathAtsText:
        'Indicas sector y puesto. La IA analiza tu CV hacia esa oferta y te dice qué mejorar. No genera un PDF nuevo.',
      pathAtsCta: 'Analizar mi CV',
      pathRewriteTitle: 'Sube tu CV: la IA lo reescribe',
      pathRewriteText:
        'Subes PDF o Word. La IA reescribe tu CV; después editas y eliges la plantilla ClarCV que prefieras.',
      pathRewriteCta: 'Subir y reescribir',
      pathsBlankEyebrow: 'Sin archivo',
      pathBlankTitle: 'Crear desde cero',
      pathBlankText:
        'Editor por secciones, eliges plantilla y descargas el PDF o Word',
      pathBlankCta: 'Abrir el editor',
      templatesTitle: '18 plantillas, y las que te imagines',
      templatesLead:
        'Looks ilimitados: elige del catálogo o describe el que quieras. Súbelo y verás cómo queda el tuyo.',
      templatesAlt: 'Plantilla de CV {name}',
      templatesCatModern: 'Moderna',
      templatesCatClassic: 'Clásica',
      templatesCatCreative: 'Creativa',
      templatesCatMinimal: 'Minimalista',
      templatesCta: 'Ver todas las plantillas con tu CV',
      templatesNote:
        'PDF con texto seleccionable: más fácil de leer para filtros automáticos que un Canva exportado como imagen',
      templatesPrev: 'Ver plantillas anteriores',
      templatesNext: 'Ver más plantillas',
      editorTitle: 'Editor y descarga',
      editorLead: 'Cuando generas o editas un CV, esto es lo que usas:',
      editor1Title: 'Por secciones',
      editor1Text: 'Editas datos, resumen, experiencia y formación por separado',
      editor2Title: 'Idioma del CV',
      editor2Text: 'El archivo en español o inglés, da igual el idioma de la web',
      editor3Title: '18 plantillas',
      editor3Text: 'Eliges el diseño al final, no al empezar',
      editor4Title: 'Vista previa',
      editor4Text: 'Ves el resultado en pantalla antes de descargar',
      editor5Title: 'PDF y Word',
      editor5Text: 'Archivos reales, listos para el portal o el email',
      priceTitle: 'Empieza gratis',
      priceLead: 'Sin tarjeta. Empieza gratis; el PDF limpio se descarga al pagar.',
      priceAmount: '0 €',
      priceAmountLabel: 'para empezar',
      priceProNote: 'Al descargar: 1,95 € / 3 días o 2,95 € este PDF. Luego 7 €/mes, cancela cuando quieras',
      priceCtaStart: 'Crear cuenta gratis',
      priceLink: 'Comparar planes →',
      blogTitle: 'Guías',
      blogLead:
        'Si ya tienes un archivo (Canva, Europass, portal), empieza por estas guías. El resto del blog cubre redacción, filtros y ChatGPT.',
      blogCta: 'Ver todas →',
    },
    pricing: {
      title: 'Empieza gratis. Pro te acompaña en cada entrevista',
      lead: 'Gratis para probar, sin tarjeta. Pro es para ir ajustando el CV a cada empresa y puesto, de la primera candidatura a la última ronda.',
      free: 'Gratis',
      free1: '1 análisis ATS de vista previa y 1 CV con IA cada 30 días',
      free2: 'Vista previa del CV en el navegador; PDF al pagar',
      free3: 'Todas las plantillas en vista previa',
      free4: 'Sin tarjeta para empezar',
      free5: 'Diseñar con IA es Pro',
      free6: 'Traducción ES ↔ EN incluida',
      startFree: 'Crear cuenta gratis',
      startEyebrow: 'Para empezar',
      laterEyebrow: 'Si lo usas más',
      recommended: 'Recomendado',
      pro: 'Pro',
      perMonth: '/mes',
      pro1: 'Ajusta el CV a cada empresa y puesto, en cada ronda',
      pro2: 'Análisis ATS ilimitados',
      pro3: 'Descargas ilimitadas en PDF y Word',
      pro4: 'Looks con IA ilimitados',
      pro5: 'Traduce y descarga en el idioma de cada oferta',
      upgrade: 'Pro 3 días por 1,95 €',
      upgradeHint: 'Luego 7 €/mes. Cancela en un clic. O este PDF por 2,95 €, sin suscripción.',
      introPeriod: ' / 3 días',
      thenMonthly: 'Luego 7 €/mes. Cancela cuando quieras.',
      oneshotCta: 'Solo este PDF · 2,95 €',
      interviewTitle: 'Un CV distinto para cada empresa',
      interviewLead:
        'En cada ronda el puesto pide otro ángulo. Con Pro vuelves a adaptar el texto, el look y la descarga: no reenvías el mismo archivo.',
      interviewCta: 'Pasar a Pro y adaptar cada oferta',
      upgrading: 'Redirigiendo...',
      loginToUpgrade: 'Crea una cuenta gratis o inicia sesión para pasar a Pro.',
      alreadyPro: 'Ya tienes el plan Pro activo.',
      youArePro: 'Eres Pro',
      youAreProLead: 'Análisis y descargas ilimitados. No hace falta volver a pagar.',
      goDashboard: 'Continuar al panel',
      leadPro: 'Gestiona tu suscripción y vuelve a mejorar tu CV cuando quieras.',
      yourPlan: 'Plan actual',
      titlePro: 'Tu plan',
      statusActive: 'Suscripción activa',
      statusEnding: 'Cancelación programada',
      leadCanceling: 'Seguirás con Pro hasta el {date}. Después pasarás al plan gratis.',
      proFootnote: '7 €/mes · mes a mes · IVA incluido · Cancela cuando quieras',
      manageBilling: 'Gestionar facturación',
      portalLoading: 'Abriendo…',
      portalError: 'No se pudo abrir el portal de facturación',
      billingReturned: 'Facturación actualizada.',
      cancelSubscription: 'Cancelar suscripción',
      cancelTitle: '¿Cancelar Pro?',
      cancelBody:
        'No se te cobrará el próximo mes. Mantienes Pro hasta el {date}.',
      cancelBodyShort:
        'No se te cobrará el próximo mes. Mantienes Pro hasta el final del periodo actual.',
      cancelFeedbackTitle: '¿Por qué cancelas? (nos ayuda a mejorar)',
      cancelReasonRequired: 'Elige un motivo para continuar.',
      cancelCommentLabel: 'Comentario (opcional)',
      cancelCommentOther: 'Cuéntanos un poco más',
      cancelCommentPlaceholder: 'Qué echas en falta, qué no funcionó, ideas…',
      cancelReasonTooExpensive: 'Es demasiado caro',
      cancelReasonMissingFeatures: 'Faltan funcionalidades',
      cancelReasonSwitched: 'Encontré una alternativa',
      cancelReasonUnused: 'Ya no lo necesito',
      cancelReasonSupport: 'El soporte no fue suficiente',
      cancelReasonComplex: 'Es difícil de usar',
      cancelReasonQuality: 'La calidad no me convence',
      cancelReasonOther: 'Otro motivo',
      cancelKeep: 'Mantener Pro',
      cancelConfirm: 'Confirmar cancelación',
      cancelDismiss: 'Cerrar',
      canceling: 'Cancelando…',
      cancelScheduled: 'Listo. Pro seguirá activo hasta el final del periodo.',
      cancelError: 'No se pudo cancelar la suscripción',
      cancelPending: 'Pro activo hasta el {date}. No se renovará.',
      cancelPendingShort: 'Pro activo hasta el final del periodo. No se renovará.',
      checkoutError: 'No se pudo abrir la pasarela de pago',
      compareTitle: 'Comparado con lo habitual del mercado',
      compareLead: 'Empiezas gratis, sin tarjeta. El PDF se paga con el precio a la vista: 1,95 € / 3 días de Pro (luego 7 €/mes) o 2,95 € este archivo. Cancela en un clic — no un trial de 25 €.',
      compareCaption:
        'Precios orientativos de planes mensuales públicos. Pueden cambiar; muchos bajan solo en el anual.',
      rowPrice: 'Precio mensual',
      rowStartFree: 'Empieza sin pagar (sin tarjeta)',
      rowImprove: 'Mejora el CV que ya tienes',
      rowTrial: 'Trial / paywall al descargar',
      rowUi: 'UI en español e inglés',
      rowOut: 'CV salida ES o EN',
      yesPdf: 'Sí (PDF/Word)',
      yesFree: 'Sí (plan gratis)',
      paywallHonest: 'Sí, precio en el botón (1,95 € / 2,95 €)',
      partial: 'Parcial',
      yes: 'Sí',
      no: 'No',
      freeLimited: 'Free limitado',
      oftenEditor: 'A menudo editor desde cero',
      frequent: 'Frecuente',
      mainlyEn: 'Principalmente EN',
      typicalEs: 'Típico ES*',
      footnote:
        '*Builders tipo Zety / LiveCareer: a menudo cobran al descargar o con suscripción tras “probar gratis”.',
      noteBefore: 'Pago seguro con Stripe. Cancela cuando quieras. Al usar el servicio aceptas la',
      privacy: 'Política de privacidad',
      noteAnd: 'y los',
      terms: 'Términos',
      noteEnd: '.',
      toastSuccess: '¡Gracias! Tu plan Pro está activo.',
      toastCanceled: 'Pago cancelado. Puedes volver cuando quieras.',
    },
    login: {
      titleLogin: 'Iniciar sesión',
      titleRegister: 'Crear cuenta',
      titleForgot: 'Recuperar contraseña',
      leadLogin: 'Accede para analizar y mejorar tu CV.',
      leadRegister:
        'Crea tu cuenta gratis, sin tarjeta. Sube el CV; el PDF limpio se descarga al pagar.',
      leadForgot:
        'Te enviamos un enlace si existe una cuenta con ese correo. Revisa también spam.',
      email: 'Correo',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      submitLogin: 'Entrar',
      submitRegister: 'Crear cuenta y verificar email',
      submitForgot: 'Enviar enlace',
      submitting: 'Espera…',
      forgotLink: '¿Olvidaste tu contraseña?',
      switchToRegister: '¿No tienes cuenta? Crear una',
      switchToLogin: '¿Ya tienes cuenta? Iniciar sesión',
      privacyNote: 'Al continuar aceptas la',
      privacy: 'Política de privacidad',
      termsNote: 'y los',
      terms: 'Términos',
      successRegisterTitle: 'Revisa tu correo',
      successRegister:
        'Hemos enviado un enlace de activación a {email}. Ábrelo para verificar tu cuenta; hasta entonces no podrás iniciar sesión.',
      successRegisterStepsTitle: 'Qué hacer ahora',
      successRegisterStep1: 'Abre tu bandeja de entrada (y la carpeta de spam).',
      successRegisterStep2: 'Busca el mensaje de ClarCV con el asunto de verificación.',
      successRegisterStep3: 'Pulsa el enlace del correo para verificar tu cuenta.',
      successRegisterStep4: 'Vuelve aquí e inicia sesión con tu email y contraseña.',
      successRegisterHint: 'El correo puede tardar un minuto. Si no llega, revisa spam o promociones.',
      goToLoginAfterRegister: 'Ya verifiqué mi correo — iniciar sesión',
      activateTitle: 'Verificar correo',
      activateLead: 'Estamos activando tu cuenta con el enlace del email…',
      activateLoading: 'Verificando tu correo…',
      activateSuccess:
        'Correo verificado. Ya puedes iniciar sesión. Te llevamos al login…',
      activateInvalid:
        'No pudimos verificar este enlace. Si ya activaste la cuenta, inicia sesión. Si el enlace tiene más de una semana, regístrate de nuevo o escribe a soporte.',
      activateAlreadyDone:
        'Tu correo ya está verificado. Puedes iniciar sesión.',
      errInactive:
        'Tu cuenta aún no está verificada. Abre el correo de ClarCV, pulsa el enlace de activación (mira también spam) y luego vuelve a iniciar sesión.',
      resetSent:
        'Si el correo está registrado, recibirás un enlace para restablecer la contraseña. En local el enlace sale en los logs del backend.',
      resetConfirmTitle: 'Nueva contraseña',
      resetConfirmLead: 'Elige una contraseña nueva para tu cuenta.',
      resetConfirmSubmit: 'Guardar contraseña',
      resetConfirmSuccess: 'Contraseña actualizada. Redirigiendo al inicio de sesión…',
      resetInvalid: 'El enlace no es válido o ha caducado. Solicita uno nuevo.',
      errGeneric: 'Algo ha fallado. Inténtalo de nuevo.',
      errEmailExists: 'Este correo ya está registrado. ¿Quieres iniciar sesión?',
      errCredentials: 'Correo o contraseña incorrectos. Revisa e inténtalo de nuevo.',
      errWeakPassword: 'Elige una contraseña más segura (mín. 8 caracteres).',
      errPasswordMatch: 'Las dos contraseñas no coinciden.',
      errUnexpected: 'Ha ocurrido un error inesperado',
      orEmail: 'o con tu correo',
      errGoogle: 'No se ha podido entrar con Google. Inténtalo de nuevo.',
      errGoogleUnavailable:
        'Google no está disponible ahora. Entra con tu correo o inténtalo más tarde.',
      errGoogleUnverified: 'Google no ha verificado ese correo. Usa otro método de acceso.',
      errGoogleNoEmail: 'Esa cuenta de Google no tiene un correo que podamos usar.',
      errAccountDisabled: 'Esta cuenta está desactivada. Escribe a soporte si crees que es un error.',
      errRateLimited: 'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
      errCaptcha: 'Completa la verificación de seguridad e inténtalo de nuevo.',
      errCredentialsGoogle:
        'Correo o contraseña incorrectos. Si te registraste con Google, usa ese botón o restablece la contraseña.',
    },
    authGate: {
      titleLogin: 'Inicia sesión para ejecutar tu CV',
      titleRegister: 'Crea una cuenta para ejecutar tu CV',
      lead:
        'Puedes explorar el editor y las plantillas sin cuenta. Pedimos acceso solo para analizar, generar o descargar.',
      close: 'Seguir explorando',
      closeAria: 'Cerrar y seguir explorando',
    },
    account: {
      eyebrow: 'Cuenta',
      title: 'Tu cuenta',
      lead: 'Tu plan, tus CVs y lo que puedes cambiar aquí.',
      helloFallback: 'tú',
      profile: 'Perfil',
      email: 'Correo',
      name: 'Nombre',
      signIn: 'Acceso',
      signInGoogle: 'Google',
      signInPassword: 'Correo y contraseña',
      plan: 'Plan',
      planFree: 'Gratis',
      planPro: 'Pro',
      planEnding: 'Pro (cancelación programada)',
      planHint: 'Cambia de plan, factura o cancela desde la página de precios.',
      planHintPro: 'Pro no tiene tope. Facturas en el portal; cancelar, en Precios.',
      planRenews: 'Se renueva el {date}',
      planUntil: 'Activo hasta el {date}',
      quotaTitle: 'Plan y uso',
      quotaWindow: 'Últimos 30 días',
      quotaAnalyses: 'Análisis ATS',
      quotaStudio: 'CV con IA',
      quotaDownloads: 'Descargas',
      quotaDesign: 'Look con IA',
      quotaLocalize: 'Traducción ES/EN',
      quotaUsedOf: '{used} de {limit}',
      quotaUnlimited: 'Ilimitado',
      quotaProOnly: 'Solo Pro',
      quotaDownloadPaywall: 'Al pagar',
      activityTitle: 'Actividad reciente',
      activityLead: 'Descargas y looks. El PDF se genera al descargar; para otro, ve al Panel.',
      activityEmpty: 'Aún no has analizado ni descargado un CV.',
      activityOpenPanel: 'Ir al panel',
      activityOpenAts: 'Ver informe',
      activityAts: 'Informe ATS',
      activityDownload: 'Descarga',
      activityAiLook: 'Look con IA',
      activityAiCv: 'CV con IA',
      activityFromScratch: 'CV desde cero',
      security: 'Seguridad',
      passwordHint: 'Para cambiar la contraseña: usa “¿Olvidaste tu contraseña?” en el inicio de sesión.',
      googlePasswordHint:
        'Entraste con Google, así que no hay contraseña. Para usar también el correo, restablece la contraseña desde el login.',
      upgrade: 'Ver planes',
      upgradeNow: 'Pasar a Pro',
      manageBilling: 'Gestionar facturación',
      help: 'Ayuda y legal',
      contact: 'Escribir a soporte',
      supportEmail: 'hola@clarcv.com',
      feedback: 'Feedback e ideas',
      feedbackHint:
        'Bugs, ideas de funcionalidades, dudas o lo que eches en falta. Respondemos en persona.',
      feedbackSubject: 'ClarCV — feedback / idea',
      feedbackBody:
        'Hola ClarCV,\n\nTipo: [ ] Bug   [ ] Idea / funcionalidad   [ ] Pregunta\n\nMensaje:\n\n\n---\nPágina o flujo (opcional):\nNavegador (opcional):\n',
      helpSubject: 'ClarCV — ayuda',
      privacyEmail: 'privacy@clarcv.com',
      deleteTitle: 'Eliminar cuenta',
      deleteHint:
        'Borra tu perfil, CVs y análisis de forma permanente.',
      deleteHintCancelPro:
        'Si tienes Pro activo, primero cancélalo en Precios. Después podrás eliminar la cuenta.',
      deleteGoCancel: 'Ir a cancelar Pro',
      deleteButton: 'Eliminar mi cuenta',
      deleteConfirmTitle: '¿Eliminar tu cuenta?',
      deleteConfirmBody:
        'Esto es permanente: se borran tus CVs, análisis y datos de cuenta. No se puede deshacer.',
      deleteTypeEmail: 'Escribe tu correo para confirmar',
      deleteTypePassword: 'Contraseña actual',
      deleteGoogleNote: 'Entraste con Google: no hace falta contraseña, solo tu correo.',
      deleteKeep: 'Mantener cuenta',
      deleteConfirm: 'Eliminar definitivamente',
      deleteWorking: 'Eliminando…',
      deleteDismiss: 'Cerrar',
      deleteDone: 'Cuenta eliminada.',
      deleteError: 'No se pudo eliminar la cuenta. Inténtalo de nuevo.',
      deleteErrConfirmation: 'Escribe tu correo para confirmar.',
      deleteErrMismatch: 'El correo no coincide con esta cuenta.',
      deleteErrPasswordRequired: 'Introduce tu contraseña para eliminar la cuenta.',
      deleteErrPassword: 'Contraseña incorrecta.',
      deleteErrStaff: 'Las cuentas de administración no se pueden borrar desde la app.',
      deleteErrCancelPro: 'Cancela Pro en Precios antes de eliminar la cuenta.',
      deleteErrStripe: 'No se pudo cortar la facturación. Inténtalo de nuevo o escribe a soporte.',
      remainingBoth: 'Te queda {ats} análisis ATS y {studio} CV con IA este mes.',
      remainingAts: 'Te queda {ats} análisis ATS este mes. El PDF se descarga al pagar.',
      remainingStudio: 'Te queda {studio} CV con IA este mes. El PDF se descarga al pagar.',
      remainingNone: 'Has usado el cupo gratis de este mes. Pasa a Pro para seguir.',
      creditPdf: '1 PDF pagado, listo para descargar',
      creditPdfs: '{n} PDF pagados, listos para descargar',
      creditAts: '1 informe ATS pagado',
      creditAtsMany: '{n} informes ATS pagados',
      libraryTitle: 'Tus informes y archivos',
      libraryLead: 'Informes ATS en vista previa. El PDF se genera al pagar; aquí ves lo que ya hiciste.',
      libraryLeadPro: 'Informes ATS completos y PDFs que ya generaste. El archivo se vuelve a crear al descargar.',
      libraryEmpty: 'Aún no hay un informe ni un PDF aquí. Sube un CV y aparecerán en esta lista.',
      libraryEmptyCta: 'Subir un CV',
      libraryOpenAts: 'Abrir informe',
      libraryOpenTeaser: 'Ver vista previa',
      libraryRewrite: 'Mejorar con IA',
      libraryScore: '{n}/100',
      libraryUntitled: 'CV subido',
      libraryNew: 'Nuevo',
      docReportTeaser: 'Informe ATS · vista previa',
      docReportFull: 'Informe ATS',
      docPdf: 'PDF',
      docWord: 'Word',
      docUpload: 'Archivo subido',
      docTeaserHint: 'Notas y plan de acción completos al desbloquear.',
      docPdfPayHint: 'El PDF no se guarda. Se genera de nuevo cuando pagas o con Pro.',
      docUnlock: 'Desbloquear informe',
      docMakeAnother: 'Hacer otro',
      docPayDownload: 'Descargar al pagar',
      quotaDetail: 'Ver cupo al detalle',
      cookiesAction: 'Cambiar cookies',
      cookiesStatus: 'Cookies',
      cookiesAnalytics: 'Analítica activa',
      cookiesAnalyticsReplay: 'Analítica y grabación de sesión',
      cookiesNecessary: 'Solo cookies necesarias',
      cookiesUnset: 'Aún no has elegido',
      signInAndPrivacy: 'Acceso y privacidad',
      passwordChange: 'Cambiar contraseña',
      passwordCurrent: 'Contraseña actual',
      passwordNew: 'Nueva contraseña',
      passwordRepeat: 'Repite la nueva contraseña',
      passwordSave: 'Guardar contraseña',
      passwordSaving: 'Guardando…',
      passwordCancel: 'Cancelar',
      passwordDone: 'Contraseña actualizada.',
      passwordSendLink: 'Enviar enlace para crear una contraseña',
      passwordLinkSent: 'Si hay una cuenta con ese correo, te enviamos el enlace.',
      passwordHintLoggedIn: 'Cámbiala aquí. No hace falta salir ni usar “olvidé la contraseña”.',
      googlePasswordAction:
        'Entraste con Google. Si también quieres correo y contraseña, te enviamos un enlace.',
      passwordWrong: 'La contraseña actual no es correcta.',
      passwordError: 'No se pudo cambiar la contraseña. Inténtalo de nuevo.',
      billingLoading: 'Abriendo…',
      cancelOnPricing: 'Cancelar Pro',
      exportMailto: 'Pedir copia de mis datos',
      exportSubject: 'ClarCV — copia de mis datos (RGPD)',
      exportBody:
        'Hola,\n\nQuiero una copia de los datos de mi cuenta ClarCV.\nCorreo: {email}\n',
    },
    feedback: {
      title: '¿Cómo va ClarCV?',
      lead: 'Una valoración rápida o una idea. Lo leemos en persona.',
      ratingLabel: 'Tu valoración',
      starN: '{n} estrellas',
      categoryLabel: 'Tipo',
      cat: {
        rating: 'Valoración',
        idea: 'Idea',
        bug: 'Bug',
        question: 'Pregunta',
      },
      messageOptional: 'Comentario (opcional)',
      messageRequired: 'Cuéntanos un poco más',
      messagePlaceholder: 'Qué funciona, qué falta, o una idea concreta…',
      submit: 'Enviar feedback',
      sending: 'Enviando…',
      thanks: '¡Gracias! Feedback enviado.',
      thanksLong: 'Gracias. Tu mensaje nos ayuda a mejorar ClarCV.',
      openPrompt: '¿Cómo va ClarCV?',
      openCta: 'Enviar feedback',
      afterDownloadTitle: 'Ya tienes tu PDF',
      afterDownloadLead:
        '¿Cómo te ha quedado? Una valoración rápida nos ayuda a mejorar ClarCV.',
      afterDownloadCta: 'Valorar el PDF',
      close: 'Cerrar',
      needRating: 'Elige una valoración con estrellas.',
      needMessage: 'Escribe al menos unas palabras.',
      error: 'No se pudo enviar. Inténtalo de nuevo.',
      rateLimited: 'Demasiados envíos. Espera un momento.',
    },
    editCv: {
      eyebrow: 'Editor',
      title: 'Tu CV',
      lead: 'El diseño está a la vista. Edita un bloque y descarga PDF o Word.',
      loading: 'Preparando el editor…',
      goUpload: 'Subir un CV',
      back: 'Volver al panel',
      template: 'Plantilla',
      clearTemplate: 'Quitar',
      chooseTemplate: 'Elegir plantilla',
      changeTemplate: 'Cambiar plantilla',
      hideLooks: 'Ocultar plantillas',
      preview: 'Vista previa',
      editMode: 'Editar',
      downloadPdf: 'Descargar PDF',
      downloadWord: 'Descargar Word',
      generating: 'Generando…',
      needTemplate: 'Elige una plantilla antes de descargar.',
      templateSelected: 'Look "{name}" aplicado',
      personal: 'Datos personales',
      summary: 'Resumen',
      experience: 'Experiencia',
      skills: 'Habilidades',
      education: 'Formación',
      languages: 'Idiomas',
      certifications: 'Certificaciones',
      achievements: 'Logros',
      cvLanguage: 'Idioma del CV',
      cvLanguageHint: 'Incluida en el plan gratis',
      cvLanguageWorking: 'Traduciendo…',
      cvLanguageFail: 'No se pudo traducir el CV. Inténtalo de nuevo.',
      cvLangEs: 'ES',
      cvLangEn: 'EN',
      previewNeedAuth: 'Entra para ver el CV con tus datos en esta plantilla.',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      zoomFit: 'Página',
      generatedOk: 'CV generado con {name}',
      looks: 'Plantillas',
      looksHint: 'Pulsa una para aplicarla',
      looksIncluded: 'Incluidas',
      seeAllLooks: 'Ver todas',
      tabDesign: 'Plantillas',
      tabPreview: 'CV',
      tabEdit: 'Editar',
      stageModeLabel: 'Cómo ves el CV',
      stageModePreview: 'Vista previa',
      stageModeOnPage: 'Editar en la plantilla',
      onTemplateToolbar: 'Formato',
      onTemplateHint: 'Haz clic en el CV para editar el texto. Arriba puedes poner negrita o color.',
      onTemplateTrial:
        'Elige una plantilla arriba. Luego vuelve a “Vista previa” para ver tu CV.',
      onTemplateTrialLive:
        'Los cambios se sincronizan con el formulario. Al descargar PDF o Word se incluye también el formato de la plantilla.',
      onTemplatePickLabel: 'Plantilla',
      onTemplatePickHint: 'Pulsa una miniatura.',
      onTemplateChangeLook: 'Cambiar',
      onTemplateHideLooks: 'Ocultar',
      onTemplateModeLabel: 'Cómo editar',
      onTemplateModeForm: 'Con formulario',
      onTemplateModeOnPage: 'En la plantilla',
      onTemplateDismissTips: 'Entendido',
      onTemplateReset: 'Restablecer texto',
      onTemplateEmpty: 'Has borrado la hoja. Pulsa Restablecer texto o elige otra plantilla.',
      fieldSummary: 'Resumen',
      fieldJobTitle: 'Puesto',
      fieldCompany: 'Empresa',
      fieldJobDesc: 'Logros / descripción',
      fieldSkills: 'Habilidades (separadas por coma)',
      onTemplatePreview: 'Ver',
      onTemplateExportFail: 'No se pudo generar el archivo. ¿Está el backend en marcha?',
      onTemplateContrastWarn:
        'Poco contraste: el texto casi no se ve sobre la página. Cambia color de texto o desactiva “Pintar todo el texto”.',
      onTemplateTextColor: 'Texto',
      onTemplateHighlight: 'Fondo',
      onTemplatePaper: 'Página',
      onTemplateSize: 'Tamaño',
      onTemplateUndo: 'Deshacer',
      onTemplateCanvas: 'CV editable',
      onTemplateSizeSm: 'Pequeño',
      onTemplateSizeMd: 'Normal',
      onTemplateSizeLg: 'Grande',
      onTemplateSizeXl: 'Título',
      onTemplateQaLabel: 'QA (solo con ?qa=1)',
      onTemplateQaStandard: 'Estándar',
      onTemplateQaSpecial: 'Ñ / símbolos',
      onTemplateQaLong: 'Texto largo',
      onTemplateQaLists: 'Listas',
      onTemplateQaSparse: 'Casi vacío',
      onTemplateQa1: '1 Nórdica',
      onTemplateQa2: '2 Oscura',
      onTemplateQa3: '3 Art Déco',
      onTemplateQa4: '4 Símbolos',
      onTemplateQa5: '5 Texto largo',
      onTemplateQa6: '6 Listas',
      onTemplateQa7: '7 Casi vacío',
      onTemplateQa8: '8 Tokio',
      onTemplateQa9: '9 París',
      onTemplateQa10: '10 Degradado',
      onTemplateDataLabel: 'Datos de ejemplo (QA)',
      onTemplateData_standard: 'Estándar',
      onTemplateData_special: 'Ñ / símbolos',
      onTemplateData_long: 'Largo',
      onTemplateData_lists: 'Listas',
      onTemplateData_sparse: 'Mínimo',
      onTemplatePaintText: 'Pintar todo el texto',
      onTemplateLoadFail: 'No se pudo cargar la plantilla. ¿Está el backend en marcha?',
      previewUpdating: 'Actualizando…',
      previewPreparing: 'Preparando tu CV…',
      previewGuest: 'Inicia sesión al descargar para ver tu CV en esta plantilla.',
      previewEmpty: 'Rellena tus datos a la derecha. El CV se actualiza aquí.',
      designWithAi: 'Diseñar con IA',
      designAiHint: 'Escribe el look',
      designAiHintPro: 'Describe el look con un texto',
      proBadge: 'PRO',
      freeBadge: 'Gratis',
      aiLookName: 'Plantilla con IA',
      designPromptLabel: 'Describe el look',
      designPromptLead:
        'Cambia color y tipo de la plantilla que estás viendo. La estructura se queda; tu texto no se toca.',
      designPromptPlaceholder: 'Ej. Fondo rojo; o marfil de revista, serif…',
      designPromptExamples: 'Ejemplos',
      designPromptEx1: 'Fondo rojo, acentos más fuertes',
      designPromptEx2: 'Revista: papel marfil, serif, título centrado',
      designPromptEx3: 'Directivo: azul marino, serif, barra a la izquierda',
      designPromptProHint: 'Genera todos los looks que quieras.',
      designPromptPayHint: 'Al generar, Pro (7 €/mes). Escribe el prompt ahora.',
      designPromptSubmit: 'Generar look',
      designPromptSubmitPro: 'Generar · Pro',
      designPromptGenerating: 'Diseñando…',
      designPromptCancel: 'Cerrar',
      designPromptNeedText: 'Escribe cómo quieres que se vea el CV.',
      designPromptOk: 'Look generado. Revisa la vista previa.',
      designPromptFail: 'No se pudo generar el look. Inténtalo de nuevo.',
      designInspectorTitle: 'Personalizar look',
      designInspectorLead:
        'Cambia un color o una fuente: el CV de la izquierda se actualiza solo. No hace falta ningún botón extra.',
      themeAccent: 'Color acento',
      themePaper: 'Fondo página',
      themeInk: 'Texto',
      themeNameFont: 'Fuente del nombre',
      themeBodyFont: 'Fuente del cuerpo',
      themeVisibility: 'Qué se ve en el CV',
      themeShow_photo: 'Foto',
      themeShow_phone: 'Teléfono',
      themeShow_email: 'Email',
      themeShow_location: 'Ubicación',
      themeShow_linkedin: 'LinkedIn',
      themeSkillIcons: 'Iconos en habilidades',
      themeSpacing: 'Espaciado',
      themeSpacingDefault: 'Normal',
      themeSpacingTight: 'Compacto',
      themeSpacingRoomy: 'Amplio',
      themeApply: 'Aplicar look',
      themeApplying: 'Actualizando el CV…',
      themeLiveHint: 'Los cambios se ven en la vista previa.',
      themeAppliedOk: 'Look aplicado. Revisa la vista previa.',
      themeAppliedFail: 'No se pudo aplicar el look.',
      themeReset: 'Volver a la plantilla original',
      themeResetOk: 'Plantilla original restaurada.',
      addExperience: '+ Añadir experiencia',
      addAnotherExperience: 'Añadir otra experiencia',
      emptyExperience: 'Aún no hay experiencia. Añade tu primer puesto.',
      experienceItem: 'Experiencia #{n}',
      addEducation: '+ Añadir formación',
      addAnotherEducation: 'Añadir otra formación',
      emptyEducation: 'Aún no hay formación. Añade tu primer título.',
      educationItem: 'Formación #{n}',
      moveUp: 'Subir',
      moveDown: 'Bajar',
      removeEntry: 'Quitar',
      reorderHint: 'Usa las flechas para cambiar el orden en el CV.',
      // Personal editor
      fieldName: 'Nombre completo',
      fieldTitle: 'Título profesional',
      fieldEmail: 'Correo',
      fieldPhone: 'Teléfono',
      fieldLocation: 'Ubicación',
      fieldWebsite: 'Sitio web',
      fieldPhoto: 'Foto de perfil',
      placeholderName: 'Nombre Apellidos',
      placeholderTitle: 'Ingeniero de software',
      placeholderEmail: 'maria.garcia@email.com',
      placeholderPhone: '+34 600 000 000',
      placeholderLocation: 'Madrid, España',
      placeholderLinkedin: 'linkedin.com/in/tu-perfil',
      uploadPhoto: 'Subir foto',
      changePhoto: 'Cambiar foto',
      removePhoto: 'Quitar foto',
      photoHint: 'Imagen cuadrada, máx. 2 MB (JPG, PNG)',
      photoTooBig: 'La foto debe pesar menos de 2 MB',
      photoInvalidType: 'Selecciona un archivo de imagen',
      // Summary editor
      summaryPlaceholder: 'Escribe un resumen profesional (2-3 frases recomendado)',
      characters: 'caracteres',
      // Tag inputs (skills, languages, certifications)
      addSkill: 'Añadir habilidad',
      addLanguage: 'Añadir idioma',
      addCertification: 'Añadir certificación',
      addTag: 'Añadir',
      tagInputPlaceholder: 'Escribe y pulsa Enter',
      // Achievements
      addAchievement: 'Añadir logro',
      achievementPlaceholder: 'Ej. Reduje los errores un 40% automatizando las pruebas',
      // Experience fields
      expFieldTitle: 'Puesto',
      expFieldCompany: 'Empresa',
      expFieldDuration: 'Duración',
      expFieldDescription: 'Descripción',
      expPlaceholderCompany: 'Nombre de la empresa',
      expPlaceholderDuration: 'Ene 2020 - Actualidad',
      expPlaceholderDescription: '• Lideré un equipo de 5 personas\n• Implementé pruebas que redujeron errores un 40%',
      // Education fields
      eduFieldDescription: 'Descripción / logros (opcional)',
      eduPlaceholderDescription: 'Asignaturas relevantes, honores, nota media, etc.',
    },
    upgrade: {
      badge: 'Pro',
      badgeOnce: 'Pago único',
      close: 'Cerrar',
      later: 'Ahora no',
      cta: 'Pro 3 días · 1,95 €',
      priceHint: '1,95 € / 3 días · luego 7 €/mes · cancela cuando quieras',
      priceAmount: '7 €',
      pricePeriod: '/mes',
      introAmount: '1,95 €',
      introPeriod: ' / 3 días, luego 7 €/mes',
      priceCancel: 'Sin permanencia. Cancela en un clic.',
      priceCancelDownload: 'Sin suscripción. O Pro 1,95 € / 3 días (luego 7 €/mes).',
      priceCancelAnalysis: 'Este informe, sin suscripción. Pro: más ATS · 1,95 € / 3 días.',
      oneshotCta: 'Solo este PDF · 2,95 €',
      oneshotAmount: '2,95 €',
      oneshotPeriod: ' este PDF, sin suscripción',
      atsCta: 'Desbloquear informe · 0,99 €',
      rewriteCta: 'Mejorar mi CV con IA',
      atsAmount: '0,99 €',
      atsPeriod: ' menos que un café, sin suscripción',
      genericTitle: 'Pasa a Pro para seguir',
      genericBody: 'Has llegado al límite del plan gratis. Pro te deja seguir analizando y descargando sin tope.',
      designTitle: 'Un look distinto para cada empresa',
      designBody:
        'Diseñar con IA es Pro. Describe el look y genera todos los que quieras, uno por oferta.',
      designPoint1: 'Looks ilimitados desde un prompt',
      designPoint2: 'Un diseño por empresa, más opciones de encajar',
      analysisTitle: '¿Vas a esperar a saber qué cambiar para que te contraten?',
      analysisBody:
        'Has visto la vista previa. Por 0,99 € se abre el plan de acción, el encaje con el puesto y el detalle por sección. Sin suscripción. Menos que un café.',
      analysisPoint1: 'Este informe ATS, ahora, por 0,99 €',
      studioTitle: '¿Quieres preparar otro CV?',
      studioBody:
        'Has usado la extracción gratis. Con Pro vuelves a pasar un archivo por la IA y lo adaptas a cada oferta.',
      studioPoint1: 'Extrae y reescribe sin tope',
      studioPoint2: 'Un CV por puesto, no el mismo archivo',
      downloadTitle: 'Tu CV está listo. Descárgalo en PDF',
      downloadBody:
        'La vista previa es gratis. Paga 2,95 € y te llevas este PDF. Si vas a enviar más de uno, Pro son 1,95 € / 3 días.',
      downloadPoint1: 'Este archivo, una vez, sin suscripción',
      downloadPoint2: 'Pro: PDF y Word ilimitados 3 días, luego 7 €/mes',
      localizeTitle: 'El mismo CV, en el idioma de la oferta',
      localizeBody:
        'Has usado la traducción ES/EN del plan gratis. Con Pro adaptas el texto a cada anuncio, en español o en inglés.',
      localizePoint1: 'Traducciones ES/EN ilimitadas',
      localizePoint2: 'Una versión por idioma y por empresa',
    },
    dashboard: {
      hello: 'Hola, {name}',
      guestHello: 'Prueba ClarCV',
      lead: 'Paso 1: ¿ya tienes un CV o partes de cero? Si subes un archivo, eliges informe de filtro (ATS) o un CV nuevo con plantilla.',
      guestLead:
        'Explora el editor y las plantillas. Pedimos cuenta solo cuando analices o generes el PDF.',
      planPro: 'Pro',
      planFree: 'Gratis',
      cvsLabel: 'CVs',
      analysesLabel: 'análisis',
      upgrade: 'Planes',
      account: 'Cuenta',
      back: 'Volver al panel',
      statsLabel: 'Resumen de uso',
      pathsLabel: 'Cómo empezar',
      stage1: 'Paso 1 de 2',
      stage2: 'Paso 2 de 2',
      quotaFree: 'Plan gratis: 1 análisis ATS, 1 CV con IA y traducción ES/EN, sin tarjeta. El PDF se descarga al pagar. Diseñar con IA es Pro.',
      emptyStep: 'Empieza aquí',
      emptyTitle: 'Sube el CV que ya tienes',
      emptyDesc: 'PDF o Word. El análisis ATS necesita el archivo; sin él no hay informe.',
      emptyLead: 'Suelta el archivo. Luego ves si el texto pasa el filtro del puesto.',
      emptyRewrite: 'Prefiero reescribirlo con IA',
      emptyKeepLook: 'Reescribir el texto (diseño lo más parecido posible)',
      fileGroup: 'Ya tienes un archivo',
      blankGroup: 'Sin archivo',
      primaryEyebrow: 'Ya tienes un archivo',
      primaryTitle: 'Mejorar mi CV',
      primaryDesc:
        'Sube el PDF o Word. Luego eliges: ver si pasa el filtro del puesto, o un CV nuevo reescrito por IA con plantilla ClarCV.',
      primaryCta: 'Continuar',
      secondaryEyebrow: 'Sin archivo',
      secondaryTitle: 'Crear un CV desde cero',
      secondaryDesc: 'Rellenas las secciones en el editor, eliges plantilla y descargas el PDF',
      secondaryCta: 'Abrir editor',
      fromFileTitle: 'Ya tienes un CV',
      fromFileLead: 'Paso 2: elige el resultado. En los tres caminos subes tu archivo.',
      rebuildLabel: 'Más completo',
      rebuildTitle: 'Nuevo CV con IA y plantilla',
      rebuildDesc:
        'Subes PDF o Word. La IA rescribe tu CV; editas y eliges la plantilla ClarCV que prefieras antes de descargar.',
      rebuildResult: 'PDF nuevo con texto mejorado. El diseño original no se conserva',
      rebuildCta: 'Empezar',
      keepLookLabel: 'Tu diseño',
      keepLookTitle: 'Reescribir el mismo CV',
      keepLookDesc:
        'Mejoramos el texto (verbos, claridad, puesto) y dejamos el aspecto lo más parecido posible. No es una copia idéntica. El Word encaja mejor que un PDF.',
      keepLookResult: 'Texto más fuerte; el diseño lo más parecido posible. El PDF se descarga al pagar',
      keepLookCta: 'Mejorar texto',
      analyzeLabel: 'Empieza aquí',
      analyzeTitle: 'Ver si mi CV pasa el filtro del puesto',
      analyzeDesc:
        'El ATS es el filtro automático de muchas empresas. Indicas sector y puesto; te decimos qué mejorar para esa oferta.',
      analyzeResult: 'Informe con notas y plan de mejora. No genera un PDF nuevo',
      analyzeCta: 'Analizar con IA',
      atsTitle: 'Informe ATS',
      atsDesc:
        'Indicas sector y puesto; te decimos qué mejorar para esa oferta. No genera un PDF nuevo.',
      atsCta: 'Analizar mi CV',
    },
    keepLook: {
      title: 'Reescribir el mismo CV',
      lead:
        'Sube tu PDF o Word. Mejoramos el texto y lo escribimos encima de tu diseño (foto, colores, columnas). No es una copia idéntica de Canva. Si tienes el .docx, el resultado encaja aún mejor.',
      stepRewrite: 'Reescribiendo el texto sin inventar experiencia',
      stepFit: 'Ajustando longitud para que quepa en tu diseño',
      stepReady: 'Preparando tu archivo',
      formatsHint: 'PDF o Word. En un PDF, descarga el PDF: el texto va encima de tu diseño. El Word es una captura.',
      cta: 'Mejorar el texto y conservar el diseño',
      analyzeOk: 'Texto mejorado. Revisa el aviso y descarga.',
      downloadOk: 'Descarga lista',
      downloadFail: 'No se pudo generar el archivo. Inténtalo de nuevo.',
      pdfUnavailable:
        'No pudimos pasar este diseño a PDF. Descarga el Word, que sí conserva el aspecto.',
      honest:
        'Mejoramos el texto sobre tu archivo. El diseño queda lo más parecido posible; no es una copia idéntica.',
      blockedHint:
        'Este archivo no se puede reescribir conservando el diseño (PDF de imagen o escaneado). Sube el Word original o usa el estudio con plantilla ClarCV.',
      downloadWord: 'Descargar Word',
      downloadWordSnapshot: 'Word (captura del diseño)',
      downloadPdf: 'Descargar PDF',
      preferStudio: 'Prefiero un CV nuevo con plantilla ClarCV',
      langHint: 'Elige ES o EN antes de mejorar. También puedes cambiarlo después.',
    },
    flow: {
      backFromFile: 'Volver a elegir camino',
      stepOf: 'Paso {current} de {total}',
      uploadTitle: 'Ver si mi CV pasa el filtro del puesto',
      uploadLead:
        'Sube tu CV. Luego indicas sector y puesto; te devolvemos un informe claro (filtro ATS) sobre qué mejorar para esa oferta.',
      dropHere: 'Suelta el archivo aquí…',
      dropOrClick: 'Arrastra tu CV aquí o haz clic para elegir',
      formats: 'Formatos: PDF, DOCX (máximo 10 MB)',
      chooseFile: 'Elegir archivo',
      processing: 'Procesando tu CV…',
      tipTitle: 'Para mejores resultados',
      tipSelectable: 'Usa un PDF o Word con texto seleccionable (no escaneado)',
      tipLength: 'Idealmente 1–2 páginas',
      uploadOk: 'CV subido correctamente',
      uploadFail: 'Error al subir el CV',
      errFileType: 'Solo se permiten PDF, DOCX o DOC',
      errFileSize: 'El archivo es demasiado grande. Máximo 10 MB',
      errNeedFile: 'Elige un archivo primero',
      errNeedConsent: 'Acepta el consentimiento de uso de IA para continuar.',
      rebuildTitle: 'Nuevo CV desde mi archivo',
      rebuildLead:
        'Sube tu CV. La IA extrae y reescribe el texto; luego eliges plantilla y descargas.',
      rebuildLeadReuse:
        'Usamos el archivo que ya subiste para el ATS. La IA lo reescribe; luego eliges plantilla y descargas.',
      usingExistingFile: 'Archivo del análisis ATS',
      usingExistingHint: 'No hace falta volver a subirlo. Puedes elegir otro si quieres.',
      chooseOtherFile: 'Elegir otro',
      rebuildTitleTemplates: 'Sube tu CV y verás las plantillas',
      rebuildLeadTemplates:
        'PDF o Word. Extraemos tu contenido y lo aplicamos a las 18 plantillas, o describes un look con un prompt.',
      uploadBoxTitle: 'Sube tu CV',
      selected: 'Seleccionado:',
      remove: 'Quitar',
      removeFile: 'Quitar archivo seleccionado',
      aiConsent:
        'Entiendo y acepto que el contenido de mi CV se envía a OpenAI solo para generar el análisis o la mejora. No se usa para entrenar modelos de IA ni se vende.',
      aiConsentRemembered:
        'Ya aceptaste el uso de IA en el análisis ATS. Lo aplicamos también aquí.',
      analyzing: 'Analizando…',
      analyzingLive: 'Analizando tu CV con IA. Esto puede tardar unos segundos.',
      analyzeProgressTitle: 'Análisis en curso',
      rewriteFromAtsTitle: 'Reescribiendo tu CV…',
      rewriteFromAtsLead:
        'Usamos el mismo archivo del análisis ATS. En un momento entras al editor, sin volver a subirlo.',
      analyzeStep1: 'Leyendo el contenido del CV…',
      analyzeStep2: 'Revisando claridad y si un filtro automático lo entendería…',
      analyzeStep3: 'Comparando con el sector y el puesto…',
      analyzeStep4: 'Preparando recomendaciones accionables…',
      generateProgressTitle: 'Generando tu CV',
      generateStep1: 'Aplicando mejoras de contenido…',
      generateStep2: 'Montando el diseño de la plantilla…',
      generateStep3: 'Preparando el archivo para descargar…',
      analyzeAndEdit: 'Analizar y editar',
      analyzeOk: 'CV analizado. Abriendo el editor…',
      analyzeFail: 'Error al analizar el CV. Inténtalo de nuevo.',
      errPdfNoText:
        'Este PDF no tiene texto seleccionable (parece un escaneo o un exportado tapado/aplanado). Sube el Word original o un PDF donde puedas seleccionar el texto con el ratón.',
      whatsNext: '¿Qué sigue?',
      next1: 'La IA analiza y reescribe tu contenido',
      next2: 'Editas las secciones en el panel',
      next3: 'Eliges una plantilla ClarCV',
      next4: 'Descargas el PDF',
      analyzeTitle: 'Analiza tu CV',
      analyzeLead:
        'Indica sector y puesto. En unos 2 minutos tendrás el informe listo.',
      analyzeFile: 'Archivo: {name}',
      industryLabel: 'Sector / industria *',
      industryHint: 'Nos ayuda a dar recomendaciones específicas de tu sector.',
      industryPlaceholder: 'ej. Tecnología, Sanidad, Finanzas, Marketing',
      jobLabel: 'Puesto objetivo',
      jobOptional: '(opcional)',
      jobHint: 'Indica el puesto para un análisis más preciso.',
      jobHintReuse: 'El mismo puesto que en el análisis ATS. Puedes cambiarlo.',
      jobPlaceholder: 'ej. Ingeniero de software senior, Responsable de marketing',
      startAnalysis: 'Iniciar análisis con IA',
      analyzeIncludesTitle: 'Qué incluye el análisis',
      analyzeInclude1: 'Puntuación global y compatibilidad ATS',
      analyzeInclude2: 'Desglose por secciones',
      analyzeInclude3: 'Recomendaciones para tu sector',
      analyzeInclude4: 'Pasos concretos para mejorar el CV',
      loadingCv: 'Cargando CV…',
      cvNotFound: 'No encontramos este CV.',
      backToDashboard: 'Volver al panel',
      analysisSubtitle: 'Lectura de reclutador y ATS, con plan de acción.',
      reportProBadge: 'Informe Pro',
      reportPreviewBadge: 'Vista previa',
      reportForJob: 'Puesto: {job}',
      reportOverall: 'Notas del CV',
      reportSummary: 'Resumen ejecutivo',
      reportFit: 'Encaje con el sector / puesto',
      reportActionTitle: 'Qué cambiar, en este orden',
      reportActionHint: 'Priorizado por impacto. La 1 es la que más mueve la nota.',
      reportActionLead: 'Haz esto primero',
      reportActionWhy: 'Por qué',
      reportActionHow: 'Cómo',
      reportActionExample: 'Ejemplo listo para pegar',
      reportDetailsKicker: 'Perspectiva RR. HH.',
      reportDetails: 'Notas de reclutador, sección a sección',
      scoreBand_excellent: 'Excelente',
      scoreBand_solid: 'Sólido',
      scoreBand_fair: 'Mejorable',
      scoreBand_weak: 'Crítico',
      scoreVerdict_excellent: 'Nivel de envío. Reescríbelo con IA para ajustar el vocabulario al anuncio.',
      scoreVerdict_solid: 'Buena base. Reescríbelo con IA y entra en más entrevistas.',
      scoreVerdict_fair: 'Hoy se queda fuera de muchos filtros. Reescríbelo con IA y sube la nota.',
      scoreVerdict_weak: 'Ni el ATS ni el reclutador tienen suficiente. Reescríbelo con IA: empieza por lo urgente.',
      teaserLead:
        'Tu nota ya está. El siguiente paso es reescribir este mismo archivo con IA: no hace falta pagar para editar.',
      teaserScoresLabel: 'Dos notas del CV',
      teaserScore: 'Contenido',
      teaserScoreHint: 'Claridad, logros y secciones. Lo que ve un reclutador.',
      teaserAts: 'Lectura ATS',
      teaserAtsHint: 'Si InfoJobs, Workday o Greenhouse pueden extraer el texto.',
      teaserKeywords: 'Palabras clave',
      teaserKeywordsHint: 'Densidad de términos del sector en el texto.',
      teaserSections: 'Desglose del contenido',
      teaserSectionContact: 'Contacto',
      teaserSectionSummary: 'Resumen',
      teaserSectionExperience: 'Experiencia',
      teaserSectionEducation: 'Formación',
      teaserSectionSkills: 'Habilidades',
      teaserStrengths: 'Lo que ya funciona',
      teaserGaps: 'Huecos que conviene mirar',
      teaserBlurb: 'Lectura rápida',
      teaserProBadge: 'Informe Pro',
      teaserLockedTitle: 'También puedes desbloquear el plan detallado',
      teaserLockedLead: 'Este informe, 0,99 €. Plan de acción, encaje con el puesto y notas de reclutador.',
      teaserUnlock1: 'Las otras 9 acciones, con ejemplos para pegar',
      teaserUnlock2: 'Frases de ejemplo listas para copiar',
      teaserUnlock3: 'Encaje con el puesto, sección a sección',
      teaserUnlock4: 'Notas de reclutador (resumen, experiencia, skills…)',
      teaserPrice: '0,99 €',
      teaserPricePeriod: 'un informe',
      teaserCtaHint: 'Un pago. Sin suscripción.',
      teaserNextPrefix: 'Empieza por: {action}',
      teaserPeekPlan: 'Plan de acción',
      teaserPeekCount: '{n} acciones',
      teaserPeekHint: 'La 1 está abierta. Las otras {rest}, con ejemplos para pegar, en el informe.',
      teaserPeekFit: 'Encaje con el puesto',
      teaserPeekHow: 'Cómo',
      teaserPeekExample: 'Ejemplo',
      teaserPeekPriority: 'Prioridad {n}',
      teaserPeekBefore: 'Ahora mismo',
      teaserPeekAfter: 'Así debe quedar',
      teaserPeekTitle1: 'Convierte las tareas en logros con cifra',
      teaserPeekTitle2: 'Reescribe el resumen para el puesto',
      teaserPeekTitle3: 'Alinea las skills con el anuncio',
      teaserPeekTitle4: 'Estandariza los títulos de sección para el ATS',
      teaserPeekTitle5: 'Deja email y teléfono en texto, no en el diseño',
      teaserPeekTitle6: 'Añade periodo y resultado a cada puesto',
      teaserPeekTitle7: 'Recorta a una página sin perder evidencia',
      teaserPeekTitle8: 'Quita adjetivos vacíos (proactivo, responsable…)',
      teaserPeekTitle9: 'Ordena la experiencia por impacto',
      teaserPeekTitle10: 'Mete las keywords del sector en resumen y skills',
      teaserPeekWhyDummy:
        'En 6–8 segundos un reclutador descarta bullets de «responsable de…». El ATS tampoco los indexa: busca verbo, cifra y resultado.',
      teaserPeekHowDummy:
        'Quédate con 3–4 bullets por puesto. Fórmula: verbo de logro + qué hiciste + número (personas, %, días, €) + resultado. Si no recuerdas la cifra exacta, usa un rango honesto.',
      teaserPeekExampleBefore:
        'Responsable de la atención al cliente y de la gestión de pedidos diarios.',
      teaserPeekExampleAfter:
        'Atendí 40–50 clientes/día en mostrador y teléfono. Unifiqué el registro de pedidos en Excel y bajé las incidencias un 18% en 4 meses.',
      teaserPeekLockedLine: 'Cómo, por qué y frase lista para pegar.',
      teaserPeekFitDummy:
        'El perfil encaja en parte, pero el resumen y las skills no usan el vocabulario del anuncio. El informe dice qué mover, sección a sección.',
      teaserCta: 'Desbloquear informe · 0,99 €',
      helpTitle: 'Reescribir este CV con IA',
      helpLead:
        'Pasa tu archivo. La IA lo reescribe para el puesto; luego eliges plantilla y ves el A4.',
      helpLeadReuse:
        'Usamos el archivo que ya subiste. Al pulsar, la IA lo reescribe y abres el editor: no hay otra pantalla de subida.',
      helpSubmit: 'Reescribir este CV con IA',
      helpHint: 'Sin tarjeta. El PDF limpio se descarga al pagar.',
      helpJobHint: 'Lo adaptamos a: {job}',
      helpJobLabel: 'Puesto objetivo',
      helpJobPlaceholder: 'ej. Product Manager, Ingeniero de software senior',
    },
  },
  en: {
    nav: {
      pricing: 'Pricing',
      blog: 'Guides',
      hello: 'Hi, {name}',
      dashboard: 'Dashboard',
      account: 'Account',
      logout: 'Log out',
      login: 'Log in',
      signup: 'Create account',
      tryApp: 'Improve my CV',
      langEs: 'ES',
      langEn: 'EN',
      langLabel: 'Language',
      planPro: 'Pro',
      planFree: 'Free',
      mainNav: 'Main navigation',
    },
    footer: {
      tagline: 'Your CV, ready for a human to read. AI does not train on your data',
      home: 'Home',
      pricing: 'Pricing',
      blog: 'Guides',
      feedback: 'Feedback',
      privacy: 'Privacy',
      terms: 'Terms',
      cookies: 'Cookies',
      login: 'Log in',
      navLabel: 'Footer links',
    },
    a11y: {
      skipToContent: 'Skip to content',
      loading: 'Loading…',
    },
    cookies: {
      regionLabel: 'Cookies',
      requiredLead: 'Choose analytics cookies before uploading or analyzing your CV.',
      body:
        'Analytics cookies (e.g. Google Analytics) to improve the site. Session recording is optional and separate.',
      sessionReplay:
        'Also allow session recording (Microsoft Clarity). May record product screens and show readable text from your CV and forms (passwords are masked). Processed by Microsoft. Withdraw anytime via Cookies.',
      accept: 'Accept',
      reject: 'Reject',
      privacy: 'Privacy',
    },
    legal: {
      privacyTitle: 'Privacy Policy',
      privacyDescription:
        'How ClarCV collects and uses your data: account, CVs, Stripe payments, and AI. We do not sell your information or train models on your CV.',
      termsTitle: 'Terms of Use',
      termsDescription:
        'Terms for using ClarCV: account, plans, your content, and limits of liability.',
    },
    blog: {
      indexTitle: 'Guides to improve your CV',
      indexDescription:
        'Practical articles on résumés, ATS filters, how to make a CV with ChatGPT or Gemini, AI prompts, and improving the PDF you already have. ClarCV.',
      indexLead:
        'Long, clear guides to pass ATS filters, use ChatGPT without inventing facts, and upgrade your PDF or Word — without shady paywalls.',
      minRead: 'min read',
      back: 'All guides',
      notFound: 'Article not found',
      ctaText: 'Want to apply this to your CV now?',
      ctaButton: 'Improve my CV on ClarCV',
      ctaUploadTitle: 'The chat drafts. The ATS reads your file',
      ctaUploadLead: 'When the draft is ready, upload PDF or Word and check if it passes the filter.',
      ctaUploadChatText: 'Draft in chat',
      ctaUploadFileText: 'PDF or Word to the filter',
      ctaUploadButton: 'Upload my CV',
      ctaUploadFine: 'Free · no card · 1 ATS preview. PDF when you pay.',
      related: 'Related guides',
      faqHeading: 'Frequently asked questions',
      filterAll: 'All',
      filterLabel: 'Filter by topic',
      guidesCount: 'guides',
      promptLabel: 'Prompt to copy',
      promptCopy: 'Copy',
      promptCopied: 'Copied',
    },
    notFound: {
      title: 'Page not found',
      lead: 'That URL does not exist or has moved. Go home or browse the blog.',
      home: 'Go to home',
      blog: 'Browse blog guides',
    },
    landing: {
      heroEyebrow: 'AI + ATS filter',
      heroTitleLead: 'Improve your CV for the',
      heroTitleAccent: 'role you want',
      heroStep1: 'Upload your PDF or Word, or start from scratch',
      heroStep2: 'Tell us the role: AI shows what to change',
      heroStep3: 'Pick a template and download as PDF or Word',
      metaTitle: 'Improve your CV for the role you want · ClarCV',
      metaDescription:
        'Upload your CV or start from scratch. AI rewrites it for the role, applies a template, and you download PDF or Word. Start free, no card.',
      ctaStart: 'Improve my CV',
      ctaBlank: 'Start from scratch',
      ctaDashboard: 'Go to dashboard',
      heroFine: 'Free · no card · edit in the browser. PDF when you pay.',
      heroAiLabel: 'AI writing assistance',
      heroAiText: 'Rewrites your CV without inventing facts or metrics',
      ariaHero: 'Introduction',
      ariaTrust: 'Trust',
      trustPrice: 'Free',
      trustPriceText: 'No card. Start free; the PDF downloads when you pay',
      trustFiles: 'PDF and Word',
      trustFilesText: 'Real downloads, ready to send',
      trustPay: 'Pro month to month',
      trustPayText: '€7/month. Cancel anytime',
      trustPrivacy: 'Privacy',
      trustPrivacyShort: 'Your CV does not train AI models',
      trustLang: 'ES + EN',
      trustLangText: 'App in your language. CV output in the language you need',
      pathsTitle: 'Choose how to start',
      pathsLead:
        'With your PDF or Word: ATS report or AI rewrite with a template. No file: build from scratch in the editor',
      pathsFileEyebrow: 'You already have a PDF or Word',
      pathAtsTitle: 'ATS report (advice only)',
      pathAtsText:
        'Set industry and role. AI analyzes your CV for that job and tells you what to improve. No new PDF.',
      pathAtsCta: 'Analyze my CV',
      pathRewriteTitle: 'Upload your CV: AI rewrites it',
      pathRewriteText:
        'Upload PDF or Word. AI rewrites your CV; then you edit and pick the ClarCV template you prefer.',
      pathRewriteCta: 'Upload and rewrite',
      pathsBlankEyebrow: 'No file',
      pathBlankTitle: 'Create from scratch',
      pathBlankText:
        'Section editor, pick a template, and download as PDF or Word',
      pathBlankCta: 'Open the editor',
      templatesTitle: '18 templates, plus any look you imagine',
      templatesLead:
        'Unlimited looks: pick from the catalog or describe the one you want. Upload yours and see how it looks.',
      templatesAlt: '{name} CV template',
      templatesCatModern: 'Modern',
      templatesCatClassic: 'Classic',
      templatesCatCreative: 'Creative',
      templatesCatMinimal: 'Minimal',
      templatesCta: 'See all templates with your CV',
      templatesNote:
        'Selectable text in the PDF: easier for automatic filters to read than a Canva export as an image',
      templatesPrev: 'See previous templates',
      templatesNext: 'See more templates',
      editorTitle: 'Editor and download',
      editorLead: 'When you generate or edit a CV, this is what you use:',
      editor1Title: 'Section by section',
      editor1Text: 'Edit details, summary, experience and education as separate blocks',
      editor2Title: 'CV language',
      editor2Text: 'Spanish or English in the file, whatever language the site is in',
      editor3Title: '18 templates',
      editor3Text: 'Pick the design at the end, not at the start',
      editor4Title: 'Live preview',
      editor4Text: 'See the result on screen before you download',
      editor5Title: 'PDF and Word',
      editor5Text: 'Real files, ready for a job board or an email',
      priceTitle: 'Start free',
      priceLead: 'No card. Start free; the clean PDF downloads when you pay.',
      priceAmount: '€0',
      priceAmountLabel: 'to start',
      priceProNote: 'On download: €1.95 / 3 days or €2.95 this PDF. Then €7/month, cancel anytime',
      priceCtaStart: 'Create a free account',
      priceLink: 'Compare plans →',
      blogTitle: 'Guides',
      blogLead:
        'If you already have a file (Canva, Europass, a job board), start with these guides. The rest of the blog covers writing, filters, and ChatGPT.',
      blogCta: 'See all →',
    },
    pricing: {
      title: 'Start free. Pro stays with you through every interview',
      lead: 'Free to try, no card. Pro is for tailoring the CV to each company and role, from the first application to the last round.',
      free: 'Free',
      free1: '1 ATS preview and 1 AI CV extract every 30 days',
      free2: 'In-browser preview; PDF when you pay',
      free3: 'All templates in preview',
      free4: 'No card to start',
      free5: 'AI design is Pro',
      free6: 'ES ↔ EN translation included',
      startFree: 'Create a free account',
      startEyebrow: 'To start',
      laterEyebrow: 'If you use it more',
      recommended: 'Recommended',
      pro: 'Pro',
      perMonth: '/mo',
      pro1: 'Tailor the CV to each company and role, every round',
      pro2: 'Unlimited ATS analyses',
      pro3: 'Unlimited PDF and Word downloads',
      pro4: 'Unlimited AI looks',
      pro5: 'Translate and download in the language of each job',
      upgrade: 'Pro 3 days for €1.95',
      upgradeHint: 'Then €7/month. Cancel in one click. Or this PDF for €2.95, no subscription.',
      introPeriod: ' / 3 days',
      thenMonthly: 'Then €7/month. Cancel anytime.',
      oneshotCta: 'This PDF only · €2.95',
      interviewTitle: 'A different CV for each company',
      interviewLead:
        'Each round asks for a different angle. With Pro you adapt the text, the look, and the file: you do not resend the same PDF.',
      interviewCta: 'Go Pro and tailor every application',
      upgrading: 'Redirecting...',
      loginToUpgrade: 'Create a free account or log in to go Pro.',
      alreadyPro: 'You already have an active Pro plan.',
      youArePro: "You're Pro",
      youAreProLead: 'Unlimited analysis and downloads. No need to pay again.',
      goDashboard: 'Continue to dashboard',
      leadPro: 'Manage your subscription and keep improving your CV anytime.',
      yourPlan: 'Current plan',
      titlePro: 'Your plan',
      statusActive: 'Active subscription',
      statusEnding: 'Cancellation scheduled',
      leadCanceling: 'You’ll keep Pro until {date}. Then you’ll move to the free plan.',
      proFootnote: '€7/mo · month to month · VAT included · Cancel anytime',
      manageBilling: 'Manage billing',
      portalLoading: 'Opening…',
      portalError: 'Could not open the billing portal',
      billingReturned: 'Billing updated.',
      cancelSubscription: 'Cancel subscription',
      cancelTitle: 'Cancel Pro?',
      cancelBody:
        'You won’t be charged next month. You keep Pro until {date}.',
      cancelBodyShort:
        'You won’t be charged next month. You keep Pro until the end of the current period.',
      cancelFeedbackTitle: 'Why are you canceling? (helps us improve)',
      cancelReasonRequired: 'Choose a reason to continue.',
      cancelCommentLabel: 'Comment (optional)',
      cancelCommentOther: 'Tell us a bit more',
      cancelCommentPlaceholder: 'What you miss, what didn’t work, ideas…',
      cancelReasonTooExpensive: 'Too expensive',
      cancelReasonMissingFeatures: 'Missing features',
      cancelReasonSwitched: 'I found an alternative',
      cancelReasonUnused: 'I no longer need it',
      cancelReasonSupport: 'Support was not enough',
      cancelReasonComplex: 'Hard to use',
      cancelReasonQuality: 'Quality was not enough',
      cancelReasonOther: 'Other reason',
      cancelKeep: 'Keep Pro',
      cancelConfirm: 'Confirm cancellation',
      cancelDismiss: 'Close',
      canceling: 'Canceling…',
      cancelScheduled: 'Done. Pro stays active until the end of the period.',
      cancelError: 'Could not cancel the subscription',
      cancelPending: 'Pro active until {date}. It won’t renew.',
      cancelPendingShort: 'Pro active until period end. It won’t renew.',
      checkoutError: 'Could not open the payment checkout',
      compareTitle: 'Compared with typical market pricing',
      compareLead: 'Start free, no card. The PDF is paid with the price on the button: €1.95 / 3 days of Pro (then €7/month) or €2.95 this file. Cancel in one click — not a €25 trial.',
      compareCaption:
        'Indicative public monthly prices. They may change; many only look cheap on annual plans.',
      rowPrice: 'Monthly price',
      rowStartFree: 'Start without paying (no card)',
      rowImprove: 'Improves the CV you already have',
      rowTrial: 'Trial / download paywall',
      rowUi: 'Spanish & English UI',
      rowOut: 'CV output ES or EN',
      yesPdf: 'Yes (PDF/Word)',
      yesFree: 'Yes (free plan)',
      paywallHonest: 'Yes, price on the button (€1.95 / €2.95)',
      partial: 'Partial',
      yes: 'Yes',
      no: 'No',
      freeLimited: 'Limited free',
      oftenEditor: 'Often build-from-scratch editor',
      frequent: 'Common',
      mainlyEn: 'Mostly EN',
      typicalEs: 'Typical ES*',
      footnote:
        '*Builders like Zety / LiveCareer often charge at download or after a “try free” subscription.',
      noteBefore: 'Secure payments with Stripe. Cancel anytime. By using the service you accept the',
      privacy: 'Privacy Policy',
      noteAnd: 'and the',
      terms: 'Terms',
      noteEnd: '.',
      toastSuccess: 'Thanks! Your Pro plan is active.',
      toastCanceled: 'Payment canceled. You can come back anytime.',
    },
    login: {
      titleLogin: 'Log in',
      titleRegister: 'Create account',
      titleForgot: 'Reset password',
      leadLogin: 'Sign in to analyze and improve your CV.',
      leadRegister:
        'Create your free account — no card. Upload the CV; the clean PDF downloads when you pay.',
      leadForgot:
        'We send a reset link if an account exists for that email. Check spam too.',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      submitLogin: 'Log in',
      submitRegister: 'Create account and verify email',
      submitForgot: 'Send reset link',
      submitting: 'Please wait…',
      forgotLink: 'Forgot your password?',
      switchToRegister: 'No account? Create one',
      switchToLogin: 'Already have an account? Log in',
      privacyNote: 'By continuing you accept the',
      privacy: 'Privacy Policy',
      termsNote: 'and the',
      terms: 'Terms',
      successRegisterTitle: 'Check your email',
      successRegister:
        'We sent an activation link to {email}. Open it to verify your account; you cannot log in until then.',
      successRegisterStepsTitle: 'What to do next',
      successRegisterStep1: 'Open your inbox (and the spam folder).',
      successRegisterStep2: 'Find the ClarCV message with the verification subject.',
      successRegisterStep3: 'Click the link in the email to verify your account.',
      successRegisterStep4: 'Come back here and log in with your email and password.',
      successRegisterHint: 'The email can take a minute. If it is missing, check spam or promotions.',
      goToLoginAfterRegister: 'I already verified — log in',
      activateTitle: 'Verify email',
      activateLead: 'Activating your account from the email link…',
      activateLoading: 'Verifying your email…',
      activateSuccess: 'Email verified. You can log in now. Taking you to login…',
      activateInvalid:
        'We could not verify this link. If you already activated the account, sign in. If the link is older than a week, sign up again or contact support.',
      activateAlreadyDone: 'Your email is already verified. You can sign in.',
      errInactive:
        'Your account is not verified yet. Open the ClarCV email, click the activation link (check spam too), then try logging in again.',
      resetSent:
        'If that email is registered, you will get a reset link. In local dev the link appears in backend logs.',
      resetConfirmTitle: 'New password',
      resetConfirmLead: 'Choose a new password for your account.',
      resetConfirmSubmit: 'Save password',
      resetConfirmSuccess: 'Password updated. Redirecting to log in…',
      resetInvalid: 'This link is invalid or expired. Request a new one.',
      errGeneric: 'Something went wrong. Please try again.',
      errEmailExists: 'This email is already registered. Want to log in?',
      errCredentials: 'Incorrect email or password. Check and try again.',
      errWeakPassword: 'Choose a stronger password (min. 8 characters).',
      errPasswordMatch: 'The two passwords do not match.',
      errUnexpected: 'An unexpected error occurred',
      orEmail: 'or continue with email',
      errGoogle: 'Could not sign in with Google. Please try again.',
      errGoogleUnavailable: 'Google Sign-In is unavailable right now. Use email or try again later.',
      errGoogleUnverified: 'Google has not verified that email. Use another sign-in method.',
      errGoogleNoEmail: 'That Google account has no email we can use.',
      errAccountDisabled: 'This account is disabled. Contact support if that looks wrong.',
      errRateLimited: 'Too many attempts. Wait a moment and try again.',
      errCaptcha: 'Complete the security check and try again.',
      errCredentialsGoogle:
        'Incorrect email or password. If you signed up with Google, use that button or reset your password.',
    },
    authGate: {
      titleLogin: 'Sign in to run your CV',
      titleRegister: 'Create an account to run your CV',
      lead:
        'You can explore the editor and templates without an account. We only ask you to sign in to analyze, generate, or download.',
      close: 'Keep exploring',
      closeAria: 'Close and keep exploring',
    },
    account: {
      eyebrow: 'Account',
      title: 'Your account',
      lead: 'Your plan, your CVs, and what you can change here.',
      helloFallback: 'there',
      profile: 'Profile',
      email: 'Email',
      name: 'Name',
      signIn: 'Sign-in',
      signInGoogle: 'Google',
      signInPassword: 'Email and password',
      plan: 'Plan',
      planFree: 'Free',
      planPro: 'Pro',
      planEnding: 'Pro (cancellation scheduled)',
      planHint: 'Change plan, invoices, or cancel from the pricing page.',
      planHintPro: 'Pro has no cap. Invoices are in the billing portal; cancel on Pricing.',
      planRenews: 'Renews on {date}',
      planUntil: 'Active until {date}',
      quotaTitle: 'Plan and usage',
      quotaWindow: 'Last 30 days',
      quotaAnalyses: 'ATS analyses',
      quotaStudio: 'AI CV',
      quotaDownloads: 'Downloads',
      quotaDesign: 'AI look',
      quotaLocalize: 'ES/EN translation',
      quotaUsedOf: '{used} of {limit}',
      quotaUnlimited: 'Unlimited',
      quotaProOnly: 'Pro only',
      quotaDownloadPaywall: 'When you pay',
      activityTitle: 'Recent activity',
      activityLead: 'Downloads and looks. The PDF is built at download time; for another, go to the dashboard.',
      activityEmpty: 'You have not analysed or downloaded a CV yet.',
      activityOpenPanel: 'Go to dashboard',
      activityOpenAts: 'Open report',
      activityAts: 'ATS report',
      activityDownload: 'Download',
      activityAiLook: 'AI look',
      activityAiCv: 'AI CV',
      activityFromScratch: 'From scratch',
      security: 'Security',
      passwordHint: 'Password changes: use “Forgot password” on the login page.',
      googlePasswordHint:
        'You signed in with Google, so there is no password yet. To also use email login, reset your password from the login page.',
      upgrade: 'See plans',
      upgradeNow: 'Upgrade to Pro',
      manageBilling: 'Manage billing',
      help: 'Help & legal',
      contact: 'Email support',
      supportEmail: 'hola@clarcv.com',
      feedback: 'Feedback & ideas',
      feedbackHint:
        'Bugs, feature ideas, questions, or anything you miss. A human replies.',
      feedbackSubject: 'ClarCV — feedback / idea',
      feedbackBody:
        'Hi ClarCV,\n\nType: [ ] Bug   [ ] Feature idea   [ ] Question\n\nMessage:\n\n\n---\nPage or flow (optional):\nBrowser (optional):\n',
      helpSubject: 'ClarCV — help',
      privacyEmail: 'privacy@clarcv.com',
      deleteTitle: 'Delete account',
      deleteHint:
        'Permanently removes your profile, CVs, and analyses.',
      deleteHintCancelPro:
        'If Pro is active, cancel it on Pricing first. Then you can delete the account.',
      deleteGoCancel: 'Go cancel Pro',
      deleteButton: 'Delete my account',
      deleteConfirmTitle: 'Delete your account?',
      deleteConfirmBody:
        'This is permanent: your CVs, analyses, and account data are removed. It cannot be undone.',
      deleteTypeEmail: 'Type your email to confirm',
      deleteTypePassword: 'Current password',
      deleteGoogleNote: 'You signed in with Google: no password needed, just your email.',
      deleteKeep: 'Keep account',
      deleteConfirm: 'Delete permanently',
      deleteWorking: 'Deleting…',
      deleteDismiss: 'Close',
      deleteDone: 'Account deleted.',
      deleteError: 'Could not delete the account. Please try again.',
      deleteErrConfirmation: 'Type your email to confirm.',
      deleteErrMismatch: 'That email does not match this account.',
      deleteErrPasswordRequired: 'Enter your password to delete the account.',
      deleteErrPassword: 'Incorrect password.',
      deleteErrStaff: 'Admin accounts cannot be deleted from the app.',
      deleteErrCancelPro: 'Cancel Pro on Pricing before deleting the account.',
      deleteErrStripe: 'Could not stop billing. Try again or contact support.',
      remainingBoth: 'You still have {ats} ATS analysis and {studio} AI CV left this month.',
      remainingAts: 'You have {ats} ATS analyses left this month. PDFs download when you pay.',
      remainingStudio: 'You have {studio} AI CVs left this month. PDFs download when you pay.',
      remainingNone: 'You have used this month’s free allowance. Upgrade to Pro to continue.',
      creditPdf: '1 paid PDF ready to download',
      creditPdfs: '{n} paid PDFs ready to download',
      creditAts: '1 paid ATS report',
      creditAtsMany: '{n} paid ATS reports',
      libraryTitle: 'Your reports and files',
      libraryLead: 'ATS reports as a preview. The PDF is built when you pay — this list is what you already ran.',
      libraryLeadPro: 'Full ATS reports and PDFs you already generated. The file is built again at download.',
      libraryEmpty: 'No report or PDF here yet. Upload a CV and it will show in this list.',
      libraryEmptyCta: 'Upload a CV',
      libraryOpenAts: 'Open report',
      libraryOpenTeaser: 'See preview',
      libraryRewrite: 'Improve with AI',
      libraryScore: '{n}/100',
      libraryUntitled: 'Uploaded CV',
      libraryNew: 'New',
      docReportTeaser: 'ATS report · preview',
      docReportFull: 'ATS report',
      docPdf: 'PDF',
      docWord: 'Word',
      docUpload: 'Uploaded file',
      docTeaserHint: 'Full notes and action plan unlock with the report.',
      docPdfPayHint: 'The PDF is not stored. It is generated again when you pay or with Pro.',
      docUnlock: 'Unlock report',
      docMakeAnother: 'Make another',
      docPayDownload: 'Download when you pay',
      quotaDetail: 'See quota details',
      cookiesAction: 'Change cookies',
      cookiesStatus: 'Cookies',
      cookiesAnalytics: 'Analytics on',
      cookiesAnalyticsReplay: 'Analytics and session recording',
      cookiesNecessary: 'Necessary cookies only',
      cookiesUnset: 'Not chosen yet',
      signInAndPrivacy: 'Sign-in and privacy',
      passwordChange: 'Change password',
      passwordCurrent: 'Current password',
      passwordNew: 'New password',
      passwordRepeat: 'Repeat new password',
      passwordSave: 'Save password',
      passwordSaving: 'Saving…',
      passwordCancel: 'Cancel',
      passwordDone: 'Password updated.',
      passwordSendLink: 'Email a link to create a password',
      passwordLinkSent: 'If an account exists for that email, we sent the link.',
      passwordHintLoggedIn: 'Change it here. You do not need to log out or use forgot-password.',
      googlePasswordAction:
        'You signed in with Google. To also use email and password, we can send you a link.',
      passwordWrong: 'That current password is not correct.',
      passwordError: 'Could not change the password. Please try again.',
      billingLoading: 'Opening…',
      cancelOnPricing: 'Cancel Pro',
      exportMailto: 'Request a copy of my data',
      exportSubject: 'ClarCV — copy of my data (GDPR)',
      exportBody:
        'Hi,\n\nI would like a copy of my ClarCV account data.\nEmail: {email}\n',
    },
    feedback: {
      title: 'How is ClarCV going?',
      lead: 'A quick rating or an idea. We read every message.',
      ratingLabel: 'Your rating',
      starN: '{n} stars',
      categoryLabel: 'Type',
      cat: {
        rating: 'Rating',
        idea: 'Idea',
        bug: 'Bug',
        question: 'Question',
      },
      messageOptional: 'Comment (optional)',
      messageRequired: 'Tell us a bit more',
      messagePlaceholder: 'What works, what is missing, or a concrete idea…',
      submit: 'Send feedback',
      sending: 'Sending…',
      thanks: 'Thanks! Feedback sent.',
      thanksLong: 'Thanks. Your note helps us improve ClarCV.',
      openPrompt: 'How is ClarCV going?',
      openCta: 'Send feedback',
      afterDownloadTitle: 'Your PDF is ready',
      afterDownloadLead: 'How did it turn out? A quick rating helps us improve ClarCV.',
      afterDownloadCta: 'Rate the PDF',
      close: 'Close',
      needRating: 'Choose a star rating.',
      needMessage: 'Write at least a few words.',
      error: 'Could not send. Please try again.',
      rateLimited: 'Too many submissions. Wait a moment.',
    },
    editCv: {
      eyebrow: 'Editor',
      title: 'Your CV',
      lead: 'The design is on screen. Edit a block and download PDF or Word.',
      loading: 'Preparing the editor…',
      goUpload: 'Upload a CV',
      back: 'Back to dashboard',
      template: 'Template',
      clearTemplate: 'Remove',
      chooseTemplate: 'Choose template',
      changeTemplate: 'Change template',
      hideLooks: 'Hide templates',
      preview: 'Preview',
      editMode: 'Edit',
      downloadPdf: 'Download PDF',
      downloadWord: 'Download Word',
      generating: 'Generating…',
      needTemplate: 'Choose a template before downloading.',
      templateSelected: 'Look "{name}" applied',
      personal: 'Personal details',
      summary: 'Summary',
      experience: 'Experience',
      skills: 'Skills',
      education: 'Education',
      languages: 'Languages',
      certifications: 'Certifications',
      achievements: 'Achievements',
      cvLanguage: 'CV language',
      cvLanguageHint: 'Included on the free plan',
      cvLanguageWorking: 'Translating…',
      cvLanguageFail: 'Could not translate the CV. Please try again.',
      cvLangEs: 'ES',
      cvLangEn: 'EN',
      previewNeedAuth: 'Sign in to see your CV with this template.',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      zoomFit: 'Fit',
      generatedOk: 'CV generated with {name}',
      looks: 'Templates',
      looksHint: 'Click one to apply it',
      looksIncluded: 'Included',
      seeAllLooks: 'See all',
      tabDesign: 'Templates',
      tabPreview: 'CV',
      tabEdit: 'Edit',
      stageModeLabel: 'How you see the CV',
      stageModePreview: 'Preview',
      stageModeOnPage: 'Edit on template',
      onTemplateToolbar: 'Format',
      onTemplateHint: 'Click the CV to edit the text. Use the bar above for bold or color.',
      onTemplateTrial:
        'Pick a template above. Then switch back to “Preview” to see your CV.',
      onTemplateTrialLive:
        'Changes sync with the form. Downloading PDF or Word also keeps formatting from the template.',
      onTemplatePickLabel: 'Template',
      onTemplatePickHint: 'Tap a thumbnail.',
      onTemplateChangeLook: 'Change',
      onTemplateHideLooks: 'Hide',
      onTemplateModeLabel: 'How to edit',
      onTemplateModeForm: 'With form',
      onTemplateModeOnPage: 'On the template',
      onTemplateDismissTips: 'Got it',
      onTemplatePreview: 'View',
      onTemplateExportFail: 'Could not generate the file. Is the backend running?',
      onTemplateContrastWarn:
        'Low contrast: text almost disappears on the page. Change text color or turn off “Recolor all text”.',
      fieldSummary: 'Summary',
      fieldJobTitle: 'Role',
      fieldCompany: 'Company',
      fieldJobDesc: 'Achievements / description',
      fieldSkills: 'Skills (comma-separated)',
      onTemplateTextColor: 'Text',
      onTemplateHighlight: 'Highlight',
      onTemplatePaper: 'Page',
      onTemplateSize: 'Size',
      onTemplateUndo: 'Undo',
      onTemplateReset: 'Reset text',
      onTemplateEmpty: 'The page is empty. Reset text or pick another template.',
      onTemplateCanvas: 'Editable CV',
      onTemplateSizeSm: 'Small',
      onTemplateSizeMd: 'Normal',
      onTemplateSizeLg: 'Large',
      onTemplateSizeXl: 'Title',
      onTemplateQaLabel: 'QA (only with ?qa=1)',
      onTemplateQaStandard: 'Standard',
      onTemplateQaSpecial: 'Accents / symbols',
      onTemplateQaLong: 'Long text',
      onTemplateQaLists: 'Lists',
      onTemplateQaSparse: 'Almost empty',
      onTemplateQa1: '1 Nordic',
      onTemplateQa2: '2 Dark',
      onTemplateQa3: '3 Art Deco',
      onTemplateQa4: '4 Symbols',
      onTemplateQa5: '5 Long text',
      onTemplateQa6: '6 Lists',
      onTemplateQa7: '7 Sparse',
      onTemplateQa8: '8 Tokyo',
      onTemplateQa9: '9 Paris',
      onTemplateQa10: '10 Gradient',
      onTemplateDataLabel: 'Sample data (QA)',
      onTemplateData_standard: 'Standard',
      onTemplateData_special: 'Accents',
      onTemplateData_long: 'Long',
      onTemplateData_lists: 'Lists',
      onTemplateData_sparse: 'Minimal',
      onTemplatePaintText: 'Recolor all text',
      onTemplateLoadFail: 'Could not load the template. Is the backend running?',
      previewUpdating: 'Updating…',
      previewPreparing: 'Preparing your CV…',
      previewGuest: 'Sign in when you download to see your CV in this template.',
      previewEmpty: 'Fill in your details on the right. The CV updates here.',
      designWithAi: 'Design with AI',
      designAiHint: 'Write the look',
      designAiHintPro: 'Describe the look in a sentence',
      proBadge: 'PRO',
      freeBadge: 'Free',
      aiLookName: 'AI template',
      designPromptLabel: 'Describe the look',
      designPromptLead:
        'Change color and type on the template you are looking at. Structure stays; your text does not change.',
      designPromptPlaceholder: 'E.g. Red background; or ivory magazine serif…',
      designPromptExamples: 'Examples',
      designPromptEx1: 'Red background, stronger accents',
      designPromptEx2: 'Magazine: ivory paper, serif, centered title',
      designPromptEx3: 'Boardroom: navy, serif, sidebar on the left',
      designPromptProHint: 'Generate as many looks as you want.',
      designPromptPayHint: 'Generating is Pro (€7/month). Write the prompt now.',
      designPromptSubmit: 'Generate look',
      designPromptSubmitPro: 'Generate · Pro',
      designPromptGenerating: 'Designing…',
      designPromptCancel: 'Close',
      designPromptNeedText: 'Describe how you want the CV to look.',
      designPromptOk: 'Look generated. Check the preview.',
      designPromptFail: 'Could not generate the look. Try again.',
      designInspectorTitle: 'Customize look',
      designInspectorLead:
        'Change a color or font: the CV on the left updates by itself. No extra button.',
      themeAccent: 'Accent color',
      themePaper: 'Page background',
      themeInk: 'Text color',
      themeNameFont: 'Name font',
      themeBodyFont: 'Body font',
      themeVisibility: 'What appears on the CV',
      themeShow_photo: 'Photo',
      themeShow_phone: 'Phone',
      themeShow_email: 'Email',
      themeShow_location: 'Location',
      themeShow_linkedin: 'LinkedIn',
      themeSkillIcons: 'Skill icons',
      themeSpacing: 'Spacing',
      themeSpacingDefault: 'Default',
      themeSpacingTight: 'Compact',
      themeSpacingRoomy: 'Roomy',
      themeApply: 'Apply look',
      themeApplying: 'Updating the CV…',
      themeLiveHint: 'Changes show in the preview.',
      themeAppliedOk: 'Look applied. Check the preview.',
      themeAppliedFail: 'Could not apply the look.',
      themeReset: 'Back to original template',
      themeResetOk: 'Original template restored.',
      addExperience: '+ Add experience',
      addAnotherExperience: 'Add another role',
      emptyExperience: 'No experience yet. Add your first role.',
      experienceItem: 'Experience #{n}',
      addEducation: '+ Add education',
      addAnotherEducation: 'Add another qualification',
      emptyEducation: 'No education yet. Add your first qualification.',
      educationItem: 'Education #{n}',
      moveUp: 'Move up',
      moveDown: 'Move down',
      removeEntry: 'Remove',
      reorderHint: 'Use the arrows to change the order on the CV.',
      // Personal editor
      fieldName: 'Full name',
      fieldTitle: 'Professional title',
      fieldEmail: 'Email',
      fieldPhone: 'Phone',
      fieldLocation: 'Location',
      fieldWebsite: 'Website',
      fieldPhoto: 'Profile photo',
      placeholderName: 'First Last',
      placeholderTitle: 'Software Engineer',
      placeholderEmail: 'maria.garcia@email.com',
      placeholderPhone: '+1 600 000 000',
      placeholderLocation: 'London, UK',
      placeholderLinkedin: 'linkedin.com/in/your-profile',
      uploadPhoto: 'Upload photo',
      changePhoto: 'Change photo',
      removePhoto: 'Remove photo',
      photoHint: 'Square image, max 2 MB (JPG, PNG)',
      photoTooBig: 'Photo must be under 2 MB',
      photoInvalidType: 'Please select an image file',
      // Summary editor
      summaryPlaceholder: 'Write a professional summary (2-3 sentences recommended)',
      characters: 'characters',
      // Tag inputs (skills, languages, certifications)
      addSkill: 'Add skill',
      addLanguage: 'Add language',
      addCertification: 'Add certification',
      addTag: 'Add',
      tagInputPlaceholder: 'Type and press Enter',
      // Achievements
      addAchievement: 'Add achievement',
      achievementPlaceholder: 'E.g. Reduced errors by 40% by automating tests',
      // Experience fields
      expFieldTitle: 'Job title',
      expFieldCompany: 'Company',
      expFieldDuration: 'Duration',
      expFieldDescription: 'Description',
      expPlaceholderCompany: 'Company name',
      expPlaceholderDuration: 'Jan 2020 – Present',
      expPlaceholderDescription: '• Led a team of 5 and shipped the project 2 weeks early\n• Automated tests that cut errors by 40%',
      // Education fields
      eduFieldDescription: 'Description / achievements (optional)',
      eduPlaceholderDescription: 'Relevant modules, honours, GPA, awards, etc.',
    },
    upgrade: {
      badge: 'Pro',
      badgeOnce: 'One-time',
      close: 'Close',
      later: 'Not now',
      cta: 'Pro 3 days · €1.95',
      priceHint: '€1.95 / 3 days · then €7/month · cancel anytime',
      priceAmount: '€7',
      pricePeriod: '/month',
      introAmount: '€1.95',
      introPeriod: ' / 3 days, then €7/month',
      priceCancel: 'No lock-in. Cancel in one click.',
      priceCancelDownload: 'No subscription. Or Pro €1.95 / 3 days (then €7/month).',
      priceCancelAnalysis: 'This report, no subscription. Pro: more ATS · €1.95 / 3 days.',
      oneshotCta: 'This PDF only · €2.95',
      oneshotAmount: '€2.95',
      oneshotPeriod: ' this PDF, no subscription',
      atsCta: 'Unlock report · €0.99',
      rewriteCta: 'Improve my CV with AI',
      atsAmount: '€0.99',
      atsPeriod: ' less than a coffee, no subscription',
      genericTitle: 'Go Pro to continue',
      genericBody: 'You have reached the free-plan limit. Pro lets you keep analysing and downloading with no cap.',
      designTitle: 'A different look for each company',
      designBody:
        'AI design is Pro. Describe the look and generate as many as you want — one per job.',
      designPoint1: 'Unlimited looks from a prompt',
      designPoint2: 'One design per company, more chances to fit',
      analysisTitle: 'Are you going to wait to find out what to change so they hire you?',
      analysisBody:
        'You have seen the preview. For €0.99 you get the action plan, role fit, and section-by-section detail. No subscription. Less than a coffee.',
      analysisPoint1: 'This ATS report, now, for €0.99',
      studioTitle: 'Want to prepare another CV?',
      studioBody:
        'You have used the free extract. Pro lets you run another file through AI and tailor it to each job.',
      studioPoint1: 'Extract and rewrite with no cap',
      studioPoint2: 'One CV per role, not the same file',
      downloadTitle: 'Your CV is ready. Download the PDF',
      downloadBody:
        'Preview is free. Pay €2.95 and take this PDF. If you will send more than one, Pro is €1.95 / 3 days.',
      downloadPoint1: 'This file, once, no subscription',
      downloadPoint2: 'Pro: unlimited PDF and Word for 3 days, then €7/month',
      localizeTitle: 'The same CV, in the language of the job',
      localizeBody:
        'You have used the free ES/EN translation. With Pro you adapt the text to each ad, in Spanish or English.',
      localizePoint1: 'Unlimited ES/EN translations',
      localizePoint2: 'One version per language and company',
    },
    dashboard: {
      hello: 'Hello, {name}',
      guestHello: 'Try ClarCV',
      lead: 'Step 1: do you already have a CV, or start blank? If you upload a file, you choose a filter report (ATS) or a new CV with a template.',
      guestLead:
        'Explore the editor and templates. We only ask for an account when you analyze or generate the PDF.',
      planPro: 'Pro',
      planFree: 'Free',
      cvsLabel: 'CVs',
      analysesLabel: 'analyses',
      upgrade: 'Plans',
      account: 'Account',
      back: 'Back to dashboard',
      statsLabel: 'Usage summary',
      pathsLabel: 'How to start',
      stage1: 'Step 1 of 2',
      stage2: 'Step 2 of 2',
      quotaFree: 'Free plan: 1 ATS preview, 1 AI CV extract, and ES/EN translation, no card. PDF when you pay. AI design is Pro.',
      emptyStep: 'Start here',
      emptyTitle: 'Upload the CV you already have',
      emptyDesc: 'PDF or Word. The ATS check needs the file; without it there is no report.',
      emptyLead: 'Drop the file. Then you see whether the text survives the job filter.',
      emptyRewrite: 'I would rather rewrite it with AI',
      emptyKeepLook: 'Rewrite the text (keep the look as close as possible)',
      fileGroup: 'You already have a file',
      blankGroup: 'No file',
      primaryEyebrow: 'You already have a file',
      primaryTitle: 'Improve my CV',
      primaryDesc:
        'Upload the PDF or Word. Next you choose: check if it passes the filter for a role, or a new CV with AI-rewritten text and a ClarCV template.',
      primaryCta: 'Continue',
      secondaryEyebrow: 'No file',
      secondaryTitle: 'Create a CV from scratch',
      secondaryDesc: 'Fill the sections in the editor, pick a template, and download the PDF',
      secondaryCta: 'Open editor',
      fromFileTitle: 'You already have a CV',
      fromFileLead: 'Step 2: pick the outcome. All three paths start with uploading your file.',
      rebuildLabel: 'Most complete',
      rebuildTitle: 'New CV with AI and template',
      rebuildDesc:
        'Upload PDF or Word. AI rewrites your CV; you edit and pick your preferred ClarCV template before downloading.',
      rebuildResult: 'New PDF with improved wording. Original layout is not kept',
      rebuildCta: 'Start',
      keepLookLabel: 'Your design',
      keepLookTitle: 'Rewrite the same CV',
      keepLookDesc:
        'We strengthen the wording (verbs, clarity, target role) and keep the look as close as possible. Not an identical copy. Word matches better than a PDF.',
      keepLookResult: 'Stronger wording; look as close as possible. PDF downloads when you pay',
      keepLookCta: 'Improve text',
      analyzeLabel: 'Start here',
      analyzeTitle: 'See if my CV passes the filter for that role',
      analyzeDesc:
        'ATS is the automatic filter many companies use. Set industry and role; we tell you what to improve for that job.',
      analyzeResult: 'Scored report and improvement plan. No new PDF is generated',
      analyzeCta: 'Analyze with AI',
      atsTitle: 'ATS report',
      atsDesc:
        'Set industry and role; we tell you what to improve for that job. No new PDF is generated.',
      atsCta: 'Analyze my CV',
    },
    keepLook: {
      title: 'Rewrite the same CV',
      lead:
        'Upload your PDF or Word. We improve the wording and write it on top of your design (photo, colours, columns). It is not an identical Canva copy. A .docx source still fits even better.',
      stepRewrite: 'Rewriting the text without inventing experience',
      stepFit: 'Fitting length so it still sits in your layout',
      stepReady: 'Preparing your file',
      formatsHint: 'PDF or Word. For a PDF, download the PDF: the text sits on your design. Word is a snapshot.',
      cta: 'Improve the text and keep the design',
      analyzeOk: 'Text improved. Check the note and download.',
      downloadOk: 'Download ready',
      downloadFail: 'Could not generate the file. Try again.',
      pdfUnavailable:
        'We could not convert this layout to PDF. Download the Word file, which keeps the look.',
      honest:
        'We improve the text on your file. The design stays as close as possible; it is not an identical copy.',
      blockedHint:
        'This file cannot be rewritten while keeping the design (image or scanned PDF). Upload the original Word or use the studio with a ClarCV template.',
      downloadWord: 'Download Word',
      downloadWordSnapshot: 'Word (snapshot of the design)',
      downloadPdf: 'Download PDF',
      preferStudio: 'I would rather use a new ClarCV template',
      langHint: 'Choose ES or EN before improving. You can switch again afterwards.',
    },
    flow: {
      backFromFile: 'Back to path choice',
      stepOf: 'Step {current} of {total}',
      uploadTitle: 'See if my CV passes the filter for that role',
      uploadLead:
        'Upload your CV. Next you set industry and role; we return a clear report (ATS filter) on what to improve for that job.',
      dropHere: 'Drop the file here…',
      dropOrClick: 'Drag your CV here or click to choose',
      formats: 'Formats: PDF, DOCX (max 10 MB)',
      chooseFile: 'Choose file',
      processing: 'Processing your CV…',
      tipTitle: 'For better results',
      tipSelectable: 'Use a PDF or Word with selectable text (not a scan)',
      tipLength: 'Ideally 1–2 pages',
      uploadOk: 'CV uploaded successfully',
      uploadFail: 'Could not upload the CV',
      errFileType: 'Only PDF, DOCX, or DOC are allowed',
      errFileSize: 'File is too large. Maximum 10 MB',
      errNeedFile: 'Choose a file first',
      errNeedConsent: 'Accept the AI processing consent to continue.',
      rebuildTitle: 'New CV from my file',
      rebuildLead:
        'Upload your CV. AI extracts and rewrites the text; then you pick a template and download.',
      rebuildLeadReuse:
        'We will use the file you already uploaded for ATS. AI rewrites it; then you pick a template and download.',
      usingExistingFile: 'File from the ATS analysis',
      usingExistingHint: 'No need to upload it again. You can choose another file if you want.',
      chooseOtherFile: 'Choose another',
      rebuildTitleTemplates: 'Upload your CV and see the templates',
      rebuildLeadTemplates:
        'PDF or Word. We extract your content and apply it to the 18 templates, or you describe a look with a prompt.',
      uploadBoxTitle: 'Upload your CV',
      selected: 'Selected:',
      remove: 'Remove',
      removeFile: 'Remove selected file',
      aiConsent:
        'I understand and accept that my CV content is sent to OpenAI only to generate the analysis or rewrite. It is not used to train AI models and is not sold.',
      aiConsentRemembered:
        'You already agreed to AI processing on the ATS analysis. We apply it here too.',
      analyzing: 'Analyzing…',
      analyzingLive: 'Analyzing your CV with AI. This may take a few seconds.',
      analyzeProgressTitle: 'Analysis in progress',
      rewriteFromAtsTitle: 'Rewriting your CV…',
      rewriteFromAtsLead:
        'We use the same file from the ATS analysis. You will land in the editor next — no second upload.',
      analyzeStep1: 'Reading your CV content…',
      analyzeStep2: 'Checking clarity and whether an automatic filter would understand it…',
      analyzeStep3: 'Matching industry and role signals…',
      analyzeStep4: 'Preparing actionable recommendations…',
      generateProgressTitle: 'Generating your CV',
      generateStep1: 'Applying content improvements…',
      generateStep2: 'Building the template layout…',
      generateStep3: 'Preparing your download file…',
      analyzeAndEdit: 'Analyze and edit',
      analyzeOk: 'CV analyzed. Opening the editor…',
      analyzeFail: 'Could not analyze the CV. Please try again.',
      errPdfNoText:
        'This PDF has no selectable text (it looks like a scan or a flattened/redacted export). Upload the original Word file, or a PDF where you can select the text with the mouse.',
      whatsNext: 'What is next?',
      next1: 'AI analyzes and rewrites your content',
      next2: 'You edit sections in the dashboard',
      next3: 'You choose a ClarCV template',
      next4: 'You download the PDF',
      analyzeTitle: 'Analyze your CV',
      analyzeLead:
        'Set industry and role. In about 2 minutes you will have the report ready.',
      analyzeFile: 'File: {name}',
      industryLabel: 'Industry / sector *',
      industryHint: 'This helps us give recommendations specific to your field.',
      industryPlaceholder: 'e.g. Technology, Healthcare, Finance, Marketing',
      jobLabel: 'Target role',
      jobOptional: '(optional)',
      jobHint: 'Add the role for a more precise analysis.',
      jobHintReuse: 'Same role as in the ATS analysis. You can change it.',
      jobPlaceholder: 'e.g. Senior software engineer, Marketing manager',
      startAnalysis: 'Start AI analysis',
      analyzeIncludesTitle: 'What the analysis includes',
      analyzeInclude1: 'Overall score and ATS compatibility',
      analyzeInclude2: 'Section-by-section breakdown',
      analyzeInclude3: 'Recommendations for your industry',
      analyzeInclude4: 'Concrete steps to improve the CV',
      loadingCv: 'Loading CV…',
      cvNotFound: 'We could not find this CV.',
      backToDashboard: 'Back to dashboard',
      analysisSubtitle: 'Recruiter and ATS reading, with an action plan.',
      reportProBadge: 'Pro report',
      reportPreviewBadge: 'Preview',
      reportForJob: 'Role: {job}',
      reportOverall: 'CV scores',
      reportSummary: 'Executive summary',
      reportFit: 'Fit for the industry / role',
      reportActionTitle: 'What to change, in this order',
      reportActionHint: 'Ranked by impact. Number 1 moves the score the most.',
      reportActionLead: 'Do this first',
      reportActionWhy: 'Why',
      reportActionHow: 'How',
      reportActionExample: 'Example ready to paste',
      reportDetailsKicker: 'Hiring-manager view',
      reportDetails: 'Recruiter notes, section by section',
      scoreBand_excellent: 'Excellent',
      scoreBand_solid: 'Solid',
      scoreBand_fair: 'Needs work',
      scoreBand_weak: 'Critical',
      scoreVerdict_excellent: 'Ready to send. Rewrite it with AI to match the ad’s language.',
      scoreVerdict_solid: 'A strong base. Rewrite it with AI and get into more interviews.',
      scoreVerdict_fair: 'This will miss a lot of filters today. Rewrite it with AI and lift the score.',
      scoreVerdict_weak: 'Neither the ATS nor a recruiter has enough. Rewrite it with AI — start with what matters.',
      teaserLead:
        'Your scores are in. Next: rewrite this same file with AI. You do not need to pay to edit.',
      teaserScoresLabel: 'Two CV scores',
      teaserScore: 'Content',
      teaserScoreHint: 'Clarity, achievements, and sections. What a recruiter sees.',
      teaserAts: 'ATS parse',
      teaserAtsHint: 'Whether InfoJobs, Workday, or Greenhouse can extract the text.',
      teaserKeywords: 'Keywords',
      teaserKeywordsHint: 'Density of industry terms in the text.',
      teaserSections: 'Content breakdown',
      teaserSectionContact: 'Contact',
      teaserSectionSummary: 'Summary',
      teaserSectionExperience: 'Experience',
      teaserSectionEducation: 'Education',
      teaserSectionSkills: 'Skills',
      teaserStrengths: 'What already works',
      teaserGaps: 'Gaps worth fixing',
      teaserBlurb: 'Quick read',
      teaserProBadge: 'Pro report',
      teaserLockedTitle: 'You can also unlock the detailed plan',
      teaserLockedLead: 'This report, €0.99. Action plan, role fit, and recruiter notes.',
      teaserUnlock1: 'The other 9 actions, with examples ready to paste',
      teaserUnlock2: 'Example lines ready to copy',
      teaserUnlock3: 'Fit for the role, section by section',
      teaserUnlock4: 'Recruiter notes (summary, experience, skills…)',
      teaserPrice: '€0.99',
      teaserPricePeriod: 'one report',
      teaserCtaHint: 'One payment. No subscription.',
      teaserNextPrefix: 'Start with: {action}',
      teaserPeekPlan: 'Action plan',
      teaserPeekCount: '{n} actions',
      teaserPeekHint: 'Number 1 is open. The other {rest}, with paste-ready examples, are in the report.',
      teaserPeekFit: 'Fit for the role',
      teaserPeekHow: 'How',
      teaserPeekExample: 'Example',
      teaserPeekPriority: 'Priority {n}',
      teaserPeekBefore: 'Right now',
      teaserPeekAfter: 'What it should look like',
      teaserPeekTitle1: 'Turn duties into results with a figure',
      teaserPeekTitle2: 'Rewrite the summary for the role',
      teaserPeekTitle3: 'Align skills with the job ad',
      teaserPeekTitle4: 'Standardise section headings for ATS',
      teaserPeekTitle5: 'Put email and phone in text, not in the design',
      teaserPeekTitle6: 'Add a time frame and a result to every role',
      teaserPeekTitle7: 'Cut to one page without losing evidence',
      teaserPeekTitle8: 'Drop empty adjectives (proactive, responsible…)',
      teaserPeekTitle9: 'Rank experience by impact',
      teaserPeekTitle10: 'Put sector keywords in the summary and skills',
      teaserPeekWhyDummy:
        'In 6–8 seconds a recruiter skips “responsible for…” bullets. An ATS does not index them either: it looks for a verb, a figure, and a result.',
      teaserPeekHowDummy:
        'Keep 3–4 bullets per role. Formula: achievement verb + what you did + a number (people, %, days, €) + the result. If you cannot recall the exact figure, use an honest range.',
      teaserPeekExampleBefore:
        'Responsible for customer service and daily order management.',
      teaserPeekExampleAfter:
        'Served 40–50 customers a day at the counter and by phone. Standardised the order log in Excel and cut incidents by 18% in 4 months.',
      teaserPeekLockedLine: 'How, why, and a line ready to paste.',
      teaserPeekFitDummy:
        'The profile partly fits, but the summary and skills do not use the language of the ad. The report says what to move, section by section.',
      teaserCta: 'Unlock report · €0.99',
      helpTitle: 'Rewrite this CV with AI',
      helpLead:
        'Upload your file. AI rewrites it for the role; then you pick a template and see the A4.',
      helpLeadReuse:
        'We use the file you already uploaded. Click once: AI rewrites it and you open the editor. No second upload screen.',
      helpSubmit: 'Rewrite this CV with AI',
      helpHint: 'No card. The clean PDF downloads when you pay.',
      helpJobHint: 'We will tailor it for: {job}',
      helpJobLabel: 'Target role',
      helpJobPlaceholder: 'e.g. Product Manager, Senior software engineer',
    },
  },
};

export default translations;
